import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { urls } from '../../common/model/properties';
import { EpahafService } from './epahaf.service';

import * as _ from 'lodash';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
//import * as _html2canvas from "html2canvas";

import { Router } from '@angular/router';
import { Subscription, forkJoin, of } from 'rxjs';
import { AlertServiceService } from '../../shared/services/alert-service.service';
import { SigninService } from '../../signin/signin.service';
import { PdfService } from './epahaf-pdf.service';

import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { SecureStorageService } from '../../secure-storage.service';
import { CupService } from '../../shared/services/cup.service';
import { Collapse ,Modal} from 'bootstrap';
import { SortDirective } from "../../shared/directive/sort.directive";
import { SortDirectiveNew } from "../../shared/directive/sort.directivenew";
import { ChangeDetectorRef } from '@angular/core';
import { RsaService } from '../../common_services/encryptutil.service';
import { ProviderportalService } from '../providerportal.service';
import { DatePipe } from '@angular/common';
import { QualityCodingGuide } from './pahaf-form/pahaf-form.component';

// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// var pdfMake = require('pdfmake/build/pdfmake');
// var pdfFonts = require('pdfmake/build/vfs_fonts');
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

declare var jQuery: any;
const MAX_API_CHUNCK_COUNT = 20;

//enum statusFormats { };Test
@Component({
    selector: 'app-epahaf',
    templateUrl: './epahaf.component.html',
    styleUrls: ['./epahaf.component.scss'],
    providers: [SigninService, EpahafService],
    standalone: false
})
export class EpahafComponent implements OnInit, OnDestroy {
  duration = '360';
  searchInput: any;
  username: any;
  p: number = 1;
  pageSize: number = 1;
  memberdetailsData: any;
  public filterForm: UntypedFormGroup;
  public RosterForm: UntypedFormGroup;
  @ViewChildren('checkboxesSelect') checkboxesSelect: QueryList<ElementRef>;
  virtualLoadingMemberDetailData: any[];
  memberdetailsPdfData: any[];
  completionStatus: any;
  copymemberDetailsData: any;
  unselectFlag: boolean = false;
  checkedList = [];
  modalRenderList = [];
  notChecked: boolean = true;
  isSelectAllInProgress: boolean = false;
  modalLoading: boolean = false;
  loadedFormsCount: number = 0;
  counter: number = 0;
  getLatest: any;
  loadingDashboard: boolean = true;
  mainHead = [];
  rows = [];
  openPane: boolean;
  openIndex: any;
  getLatestforPahaf: any;
  getLatestforChart = [];
  getLatestforPahafChart: any;
  hovering: boolean;
  hoveringRow: any;
  openFrameFlag: boolean;
  generateButtonFlag: boolean = true;
  disableDropdown: boolean = false;
  golbalFileType: any;
  globalFiletypeforchart: any;
  providerIds = [];
  selectedids: string;
  AllDocuments = [];
  pcpDocList = [];
  generateUnsubmittedDoc: boolean = false;
  noDocs = [];
  errorForCriteria: boolean = false;
  indexOfClickedRow: any;
  documentLoading: boolean = false;
  cities = [];
  statusType: boolean;
  subscription: Subscription;
  completeFlag: boolean = false;
  incompleteFlag: boolean = false;
  allCompleteDataforFilter = [];
  allPendingDataforFilter = [];
  allfilterFlag: boolean = true;
  allFilterdData = [];
  pendingData = [];
  subMittedData = [];
  data = [];
  savedStatusArray = [];
  eachContentList = [];
  memberArrayList = [];
  duplicates = [];
  formitems = [];
  dataForInterval: any;
  intervalForLoading: any;
  selectedTab = 0;
  cardData = [];
  cardDataWithMemberIdList: IMemberIdYearMapping[];
  saveAlertId: any;
  copyCardData = [];
  copyOfcardData: any;
  isUnReadValue: boolean;
  unReadAlertCount: any;
  eachTabFlag: boolean;
  countToshow: any;
  countSubscription: Subscription;
  specificTabFlag: any;
  noDataFoundFlag: any;
  noCardFoundforHigh: boolean;
  noCardFoundforMed: boolean;
  noCardFoundforlow: boolean;
  unReadAlertCountwithSev: any;
  unreadHighCount = 0;
  unreadMedCount = 0;
  unreadLowCount = 0;
  allUnreadAlertCount: any;
  myParam: any;
  appValue: string;
  highCountSubscription: Subscription;
  medCountSubscription: Subscription;
  lowCountSubscription: Subscription;
  allCountSubscription: Subscription;
  noDataFoundFlagLow: boolean;
  noDataFoundFlagMed: boolean;
  PdfDataPresent: boolean = false;
  selectedPdfObject: any = [];
  parentValue: string[];
  pahafYear: string;
  dropdownList = [];
  dropdownListRefresh = [];
  selectedPahafStatus = [];
   selectedPahafStatusRefresh = [];
  dropdownSettings = {};
  tempDDFilter = [];
  isSecondDropdownDisabled: boolean = true;
  isBulkDownloadModalOpen: boolean = false;

  file: File = null;
  radioBtn: any;
  loading: boolean = false;

  shortLink: string = '';
  multiFile: boolean = false;
  //selectedFiles: FileList;
  selectedFiles: any = [];
  selectedFilesSingle: any = [];
  selectedFilesBoth: any = [];
  Pahaffile: any;
  Chartfile: any;
  PahafChartfile: any;

  fileId: any;
  deleteprvname: any;

  uploadmemid;
  uploadFlag: boolean = true;
  uploadFlag1: boolean = true;
  isUploadLoading: boolean = false;

  eachContentListUpload = [];
  memberArrayListUpload = [];

  uploadDocumentFlag: boolean;
  dataForUpload: any;
  message: string;
  chunks = [];

  refreshSortData: boolean = false;
  private lastSortField: string = ''; 
  private lastSortOrder: string='';

    items: any;
  memberId = '';
  gender: string;
  date: any;
  date_gender: string;
  formDataArray = [];
  indicatorOfConditions = '';
  prevCondition = [];
  poteintialCondition = [];
  prevFlag: boolean;
  ptnFlag: boolean;
  newpoteintialCondition: any;
  status = {};
  allStatus = [];
  singleMemberdetails: any;
  uniquePrevCondition = [];
  radio_Q2;
  radio_Q3;
  radio_Q4;
  bpTextBox1;
  bpTextBox2;
  bpCheckbox1;
  bpCheckbox2;
  bpCheckbox3;
  bpCheckbox4;
  cb81;
  date1;
  cb811;
  cb82;
  date2;
  cb821;
  cb83;
  date3;
  cb831;
  cb84;
  date4;
  cb841;
  submissionDate;
  result: any[][];
  memberMeasureDatas = [];
  qualityCodingListData = [];
  public measuresListData:any = [];
  public measuresListDataArray:any = [];
  public qualityHeaderList : any = [];
  public qualityCodingList : any = [];
  public dxDt : any = [];
  public hccDt : any = [];
  public resultDx: any [][];
  public resultHcc: any [][];
  public refreshDate: any = [];
  public refreshDateN:any = [];
  public pipe = new DatePipe('en-US');
  selectedmemberdetailsPdfData : any[];
  currentPage: number = 1;
pageSize1: number = 10;


  @ViewChild('pdfTable') pdfTable: ElementRef;
  images: any = {
    logo: '',
    systolic: '',
    cancerScreening: '',
    signature: '',
    alogo: '',
    dlogo: '',
    ulogo: '',
    adulogo: '',
    diabetes: '',
    checkbox: '',
    rectBig: '',
    starMeasure: '',
  };

  @ViewChildren(SortDirectiveNew)  sortDirectives!: QueryList<SortDirectiveNew>;


  uniquePcpList: any = [];
  qualityMeasureList: any = [];
  errMsg504 =
    'We are experiencing temporary connectivity issues. The request took too long to process. Please try again later. If the problem persists, reach out to Provider Relations team at ProviderRelations@caremore.com .';
  errMsg500 =
    'An Unexpected error occured on the server. Please try again later.  If the error continues, please contact our Provider Relations team at ProviderRelations@caremore.com ';
  displayErrMsg = this.errMsg504;
  showPahafInfo = true;
  prpModules: any=[];
  warningsMsgs : any=[];
  addItem(newItem: any) {
    this.selectedTab = newItem.index;
    //////console.log("input from tab", newItem);
  }
  addMarkAsRead() {
    //////console.log("readCardId", item);
  }
  setFlag(flags: any) {
    this.eachTabFlag = flags.someFlag;
    this.specificTabFlag = flags.everyFlag;
    this.noDataFoundFlag = flags.noCardFound;
    //////console.log("this.eachTabFlag", flags);
  }
  public checkEmergency() {
    this.selectedTab = 1;
  }
  public checkNonEmergencyTab() {
    this.selectedTab = 2;
  }
  handleResults(searchObj) {
    this.data = searchObj;
  }
  constructor(
    private router: Router,
    private cupService: CupService,
    private alertService: AlertServiceService,
    private epahafService: EpahafService,
    private fb: UntypedFormBuilder,
    public signinService: SigninService,
    private PdfService: PdfService,
    private secureStorage: SecureStorageService,
    private httpClient: HttpClient,
    private cdr: ChangeDetectorRef,
    private util:RsaService,
    private currentService: ProviderportalService,
    private pahafService: EpahafService,
  ) {
    this.filterForm = this.fb.group({
      statusType: [],
    });

    this.RosterForm = this.fb.group({
      rosterType: [],
    });

    this.dataForInterval = setInterval(() => {
      this.getStatusInInterval();
    }, 10000);

    this.dataForUpload = setInterval(() => {
      this.getUploadStatus();
    }, 10000);
  }

  getvalue(value, key) {
    for (let i = 0; i < value.keyvaluePairWr.length; i++) {
      if (value.keyvaluePairWr[i].key === key) {
        return value.keyvaluePairWr[i].value;
      }
    }
  }

  viewPAHAFWorkflowDoc() {
    this.loadingDashboard = true;
    const kvpl = [{ value: 'Pahaf-workflow', key: 'FileDescription' }];
    this.epahafService.listDocuments(kvpl).subscribe((data) => {
      const doc = <any>data;
      if (doc && doc.keyValuePairListWrapperlist) {
        const docId = this.getvalue(doc.keyValuePairListWrapperlist[0], 'Id');
        this.epahafService.getWorkFlowDocument(docId, 'GEN_REF_DOC').subscribe(
          (responseData) => {
            if (responseData) {
              if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                const blob = this.binary64ToBlob(
                  responseData.docContent,
                  responseData.fileType,
                  512
                );
                saveAs(blob, responseData.filename);
                this.loadingDashboard = false;
              } else {
                const blob = this.b64toBlob(
                  responseData.docContent,
                  responseData.fileType,
                  512
                );
                const urlBlob = URL.createObjectURL(blob);
                this.loadingDashboard = false;
                window.open(urlBlob);
              }
            }
          },
          () => {
            this.openModal('errorModal');
            this.loadingDashboard = false;
          }
        );
      }
    });
  }

  async ngOnInit() {
    //////console.log("ts file oninit")
    // this.loadingDashboard = true;
    this.prpModules =await this.getPRPmodules();
    await  this.getPahafDyanamicRefreshMsg()

    this.username = this.cupService.getUserNameFromJWT();
    // this.myParam = this.route.snapshot.params.myParam;
    let url = this.router.url;
    this.appValue = url.split('/')[2];
    //////console.log("param", this.appValue);
    await this.loadQualityMeasureData();

    this.dropdownList = [
      { id: 5, itemName: 'Not Received' },
      { id: 7, itemName: 'Portal In Progress' },
      { id: 3, itemName: 'Denied' },
      { id: 6, itemName: 'On Hold - Missing claim' },
      { id: 8, itemName: 'On Hold - Non-AWV Claim' },      
      { id: 1, itemName: 'Pending Coder Review' },
      { id: 2, itemName: 'Payment Approved' },
      { id: 4, itemName: 'Paid' },
      
      // {"id":6,"itemName":"Provider feedback"},

  

    ];

    this.dropdownListRefresh = [
      { id: 1, itemName: 'New Patient Form' },
      { id: 3, itemName: 'Conditions Added' },
      { id: 2, itemName: 'No Conditions Added' },
      
    ];

    this.dropdownSettings = {
      singleSelection: false,
      //text:"Select PCP",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //enableSearchFilter: true,
      //classes:"myclass custom-class"
      badgeShowLimit: 1,
    };

    //pahafYear
    this.epahafService.getpahafconfiginfo().subscribe((response) => {
      let responseData: any;
      responseData = response;
      this.pahafYear = responseData[0].pahafValue;
    });
    //notifications
    this.alertService.getAllCounts();
    this.alertService.getDataFromDB();
    this.allUnreadAlertCount = this.alertService.allCount;
    this.unreadHighCount = this.alertService.unreadHighCount;
    this.unreadMedCount = this.alertService.unreadMedCount;
    this.unreadLowCount = this.alertService.unreadLowCount;

    if (!this.cardData) this.cardData = [];
    let items = JSON.parse(
      this.secureStorage.getSecureInfoInSessionStorage('arraylist')
    );
    if (items) {
      items.forEach((e) => {
        this.memberArrayList.push(e);
      });
      this.getStatusInInterval();
    } else {
      this.memberArrayList = [];
    }

    let itemsUpload = JSON.parse(
      this.secureStorage.getSecureInfoInSessionStorage('arraylistUpload')
    );
    if (itemsUpload) {
      itemsUpload.forEach((e) => {
        this.memberArrayListUpload.push(e);
      });
      this.getUploadStatus();
    } else {
      this.memberArrayListUpload = [];
    }

    this.getMemberdetails(this.username);
    //alert subscription starts
    this.allCountSubscription =
      this.alertService.allUnreadserviceAlertCount.subscribe((all) => {
        if (all) {
          this.allUnreadAlertCount = all.allCountwithSev;
          this.unreadHighCount = all.highCount;
          this.unreadMedCount = all.medCount;
          this.unreadLowCount = all.lowCount;
        }
      });
    this.subscription = this.alertService.message.subscribe((message) => {
      let unfilteredincomingAlerts = message;
      // let incomingAlerts = unfilteredincomingAlerts.filter(
      //   x => x.APPLICATION_ID.toLowerCase() === this.appValue
      // );
      // //////console.log('unfilteredincomingAlerts',unfilteredincomingAlerts);
      let incomingAlerts = unfilteredincomingAlerts.filter((x) => {
        if (x.APPLICATION_ID !== null) {
          return x.APPLICATION_ID.toLowerCase() === this.appValue;
        }
      });
      // //////console.log('incomingAlerts',incomingAlerts);
      this.isUnReadValue = true;
      this.noCardFoundforHigh = true;
      let finalData = [];
      if (
        incomingAlerts &&
        Array.isArray(incomingAlerts) &&
        incomingAlerts.length
      ) {
        let newAlerts = _.differenceBy(
          incomingAlerts,
          this.cardData,
          'AlertId'
        );
        if (
          newAlerts &&
          newAlerts.length &&
          Array.isArray(this.cardData) &&
          this.cardData.length > 0
        ) {
          finalData = [...newAlerts, ...this.cardData];
        } else if (
          this.cardData &&
          this.cardData.length === 0 &&
          incomingAlerts &&
          incomingAlerts.length
        ) {
          finalData = incomingAlerts;
        } else if (this.cardData && this.cardData.length) {
          finalData = this.cardData;
        }
        if (
          newAlerts.length === 0 &&
          !_.isEqual(this.cardData, incomingAlerts)
        ) {
          let allNeedToChange = this.cardData.every((temp) => {
            return temp.IsUnRead === '0';
          });
          if (allNeedToChange) finalData = incomingAlerts;
        }
        if (!_.isEqual(this.cardData, incomingAlerts)) {
          incomingAlerts.forEach((each: any) => {
            if (each.isCardOpened) {
              let openCard = _.findIndex(this.cardData, {
                AlertId: each.AlertId,
              });
              this.cardData.splice(openCard, 1, each);
            }
          });
        }
        setTimeout(() => {
          this.cardData = finalData;

          // this.countSubscription = this.alertService.countwithSev.subscribe(
          //   (e) => {
          //     this.unReadAlertCountwithSev = e;
          //     if (
          //       this.unReadAlertCountwithSev &&
          //       this.unReadAlertCountwithSev.length > 0
          //     ) {
          //       this.unReadAlertCountwithSev.forEach((elementwithSev) => {
          //         if (elementwithSev.Severity.toLowerCase() === "high") {
          //           this.unreadHighCount = elementwithSev.Count;
          //         } else if (
          //           elementwithSev.Severity.toLowerCase() === "medium"
          //         ) {
          //           this.unreadMedCount = elementwithSev.Count;
          //         } else if (
          //           elementwithSev.Severity.toLowerCase() === "low"
          //         ) {
          //           this.unreadLowCount = elementwithSev.Count;
          //         }
          //       });

          //       this.allUnreadAlertCount =
          //         this.unreadHighCount +
          //         this.unreadMedCount +
          //         this.unreadLowCount;
          //       //////console.log("AllunreadCount", this.allUnreadAlertCount);
          //     }
          //   }
          // );
          this.isUnReadValue =
            finalData.length === 0
              ? true
              : this.cardData.every((temp) => {
                  return temp.IsUnRead === '0';
                });
          let filteredHighCardData = this.cardData.filter(
            (x) => x.Severity.toLowerCase() === 'high'
          );
          // //////console.log('filteredHighCardData',filteredHighCardData);
          if (filteredHighCardData.length > 0) {
            this.eachTabFlag = false;
            this.specificTabFlag = false;
            this.noCardFoundforHigh = filteredHighCardData.every((temp) => {
              return temp.IsUnRead === '0';
            });
          }
          let filteredMedCardData = this.cardData.filter(
            (x) => x.Severity.toLowerCase() === 'medium'
          );
          // //////console.log('filteredMedCardData',filteredMedCardData);
          if (filteredMedCardData.length > 0) {
            this.eachTabFlag = false;
            this.specificTabFlag = false;
            this.noDataFoundFlagMed = filteredMedCardData.every((temp) => {
              return temp.IsUnRead === '0';
            });
          }
          let filteredlowCardData = this.cardData.filter(
            (x) => x.Severity.toLowerCase() === 'low'
          );
          // //////console.log('filteredMedCardData',filteredlowCardData);
          if (filteredlowCardData.length > 0) {
            this.eachTabFlag = false;
            this.specificTabFlag = false;
            this.noDataFoundFlagLow = filteredlowCardData.every((temp) => {
              return temp.IsUnRead === '0';
            });
          }
        }, 10);
      }
    });
    // this.intervalForLoading = setInterval(() => {
    //   let fromService = JSON.parse(
    //     this.secureStorage.getSecureInfoInLocalStorage("memberdetailsPdfData")
    //   );
    //   let flag = this.secureStorage.getSecureInfoInLocalStorage("dataSaved");
    //   // this.loadingDashboard = true;
    //   if (flag === "true") {
    //     this.getMemberdetails(this.username.userName);
    //     this.secureStorage.setSecureInfoInLocalStorage("dataSaved", "false");

    //   } else if (flag === "false" && fromService.length === 0){
    //     this.loadingDashboard = false;
    //     this.virtualLoadingMemberDetailData = ['No Data found '];
    //     clearInterval(this.intervalForLoading);
    //   } else if(!flag && fromService.length === 0){
    //     this.loadingDashboard = false;
    //     this.virtualLoadingMemberDetailData = ['No Data found '];
    //     clearInterval(this.intervalForLoading);
    //     // this.getMemberdetails(this.username.userName);
    //   }
    // }, 10);
    // this.getAllAlerts();

    this.epahafService.epahafPdfData.subscribe((pdf: any) => {
      if (Object.keys(pdf).length) {
        this.selectedPdfObject.push(pdf);
      }
    });
  }


  getPRPmodules(){
    return this.currentService.getPRPModules().toPromise();

  }
  getPahafDyanamicRefreshMsg(){
    if(this.prpModules.modulesList.length>0){
      this.loadingDashboard=true;
          for(let prpModule of this.prpModules.modulesList){
                if(prpModule.moduleName==="PAHAF"){
                    this.currentService.getWarningMsgs(prpModule.moduleUid.toString(), (success: boolean, warning: any) => {
                     if (success) {
                     this.loadingDashboard=false;
                         if (warning.providerPortalBroadcast.length > 0) {
                                const broadcast=warning.providerPortalBroadcast[0];
                            this.warningsMsgs.push(broadcast);
            }
          }else{
          this.loadingDashboard=false;
          this.warningsMsgs=[];
          }

        });
     }
  }
 }
}
openModal(modalId: string) {
    const modalElement = document.getElementById(modalId);
    const modal = new Modal(modalElement);
    
    // Add event listener to clear modalRenderList when modal is closed
    if (modalId === 'previewPDF') {
      modalElement.addEventListener('hidden.bs.modal', () => {
        this.modalRenderList = [];
        this.modalLoading = false;
        this.loadedFormsCount = 0;
      }, { once: true });
    }
    
    modal.show();
  }
  closeModal(modalId: string) {
    const modalElement = document.getElementById(modalId);
    const modal = Modal.getInstance(modalElement);  
    if(modal!=null){
      modal.hide();
    }
  }


  async loadQualityMeasureData() {
    return new Promise((resolve) => {
      this.epahafService.getProviderBasicDetails().subscribe((data) => {
        const providerDetails = data;
        if (providerDetails && providerDetails.length > 0) {
          providerDetails.map((siteUser) => {
            if (
              siteUser &&
              siteUser.providers &&
              siteUser.providers.length > 0
            ) {
              siteUser.providers.map((element) => {
                if (
                  element.region.indexOf('OBSOLETE') === -1 &&
                  element.pcp != false
                ) {
                  if (
                    _.findIndex(this.uniquePcpList, {
                      providerId: element.providerId,
                      providerNo: element.providerId + element.regionCode,
                    }) == -1
                  ) {
                    let obj = {
                      providername: element.name,
                      providerId: element.providerId,
                      providerNo: element.providerId + element.regionCode,
                      regionCode: element.regionCode,
                    };
                    this.uniquePcpList.push(obj);
                    // this.getQmDashboardMemberData(this.uniquePcpList[element.providerId]).then((res) => {
                    //   //////console.log('ress :', res)
                    // })
                  }
                }
              });
            }
          });
          if (this.uniquePcpList.length) {
            let apiCallsLen = this.uniquePcpList.length;
            if (MAX_API_CHUNCK_COUNT > apiCallsLen)
              this.iterateApiCalls(0, apiCallsLen);
            else this.iterateApiCalls(0, MAX_API_CHUNCK_COUNT);

            resolve(true);
          }
        } else {
          this.loadingDashboard = false;
          this.memberdetailsData = ['No Data found '];
          this.virtualLoadingMemberDetailData = ['No Data found '];
          this.memberdetailsPdfData = ['No Data found'];
        }
      });
    });
  }

  iterateApiCalls(startIndex, lastIndex) {
    if (lastIndex <= this.uniquePcpList.length) {
      let apiCallList = [];
      let arr = this.uniquePcpList.slice(startIndex, lastIndex);
      arr.map((data) =>
        apiCallList.push(
          this.epahafService.getMemberMeasureDetails(
            data.regionCode,
            data.providerId
          )
        )
      );

      const observables = forkJoin(apiCallList);
      observables.subscribe({
        next: (res: any) => {
          if (Object.keys(res).length) {
            this.qualityMeasureList.push(res);
          }
        },
        complete: () => {
          this.iterateApiCalls(lastIndex, lastIndex + MAX_API_CHUNCK_COUNT);
        },
      });
    } else {
      this.qualityMeasureList = [].concat(...this.qualityMeasureList);
    }
  }
  measurecount: any = [];
  getQualityMeasureCount(id, memberid) {
    ////////console.log("getQuality measurecount :",this.qualityMeasureList)
    let res =
      this.qualityMeasureList.filter(
        (item) => item.prvid == id && item.result[memberid] !== undefined
      ) || [];
    ////////console.log("res.result['_body'] :",res)
    if (res && res.length) {
      ////////console.log("res.length--:",res.length)
      var str = id + '_' + memberid;
      this.measurecount[str] = res[0].result[memberid];

      //this.measurecount.push(obj)
      return res[0].result[memberid];
    } else {
      return 0;
    }
  }

  getCount(pcpid, memid) {
    var str = pcpid + '_' + memid;
    if (this.measurecount[str]) {
      ////////console.log("this.measurecount[str]--:",this.measurecount[str])
      return this.measurecount[str];
    } else return 0;
    //return this.measurecount[str] || 0;
    // let cnt = this.measurecount.filter(itm => itm.id == str)
    // if (cnt && cnt.length) {
    //   ////////console.log("cnt[0].count---:",cnt[0].count)
    //   return cnt[0].count
    // }
    // else return 0;
  }

  onItemSelect(event) {
    const refreshValue = this.selectedPahafStatus.filter(item => item.id == 5);
      if(refreshValue.length > 0) {
        this.isSecondDropdownDisabled = false;
      }
      else {
        this.isSecondDropdownDisabled = true;
      }
    console.log("refreshValue --:",refreshValue)
    this.dropdownfilterMembers();
  }

  onItemSelect1(event) {
    console.log("select 1")
    this.dropdownfilterMembers();
  }


  OnItemDeSelect(event) {
    ////////console.log(item);
    if (this.selectedPahafStatus.length === 0 && !this.searchInput) {
      this.allFilterdData = [];
      this.onDeSelectAll(event);
    } else {
      if (this.selectedPahafStatusRefresh.length !== 0 ) {
        this.selectedPahafStatusRefresh = [];
      }
      const refreshValue = this.selectedPahafStatus.filter(item => item.id == 5);
      if(refreshValue.length > 0) {
        this.isSecondDropdownDisabled = false;
      }
      else {
        this.isSecondDropdownDisabled = true;
      }
      this.dropdownfilterMembers();
    }
  }

  OnItemDeSelect1(event) {
    console.log("de select 1")
     //if (this.selectedPahafStatusRefresh.length === 0 && !this.searchInput) {
      if (this.selectedPahafStatusRefresh.length === 0 ) {
      this.allFilterdData = [];
      this.onDeSelectAll1(event);
    } else {
      this.dropdownfilterMembers();
    }

  }

  onSelectAll(event) {   
     const refreshValue = this.selectedPahafStatus.filter(item => item.id == 5);
      if(refreshValue.length > 0) {
        this.isSecondDropdownDisabled = false;
      }
      else {
        this.isSecondDropdownDisabled = true;
      } 
    this.dropdownfilterMembers();
  }

  onSelectAll1(event) {
    //console.log("select all 1");
    this.dropdownfilterMembers();
  }


  onDeSelectAll(event) {
    ////////console.log(items);
    this.loadingDashboard = true;
    if (this.selectedPahafStatusRefresh.length !== 0 ) {
        this.selectedPahafStatusRefresh = [];
      }
     const refreshValue = this.selectedPahafStatus.filter(item => item.id == 5);
      if(refreshValue.length > 0) {
        this.isSecondDropdownDisabled = false;
      }
      else {
        this.isSecondDropdownDisabled = true;
      }
    this.tempDDFilter = this.memberdetailsPdfData;
    if (this.tempDDFilter.length) {
      if (this.tempDDFilter.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempDDFilter.slice(0, 49);
        const displaysElement = document.getElementById('displays');
        if (displaysElement) {
          displaysElement.style.display = 'block';
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempDDFilter;
        const displaysElement = document.getElementById('displays');
        if (displaysElement) {
          displaysElement.style.display = 'none';
        }

      }
    } else {
      this.virtualLoadingMemberDetailData = [
        'No records found for the searched criteria',
      ];
      const displaysElement = document.getElementById('displays');
      if (displaysElement) {
        displaysElement.style.display = 'none';
      }
    }
    ////////console.log(this.virtualLoadingMemberDetailData.length);

    this.loadingDashboard = false;
  }

  onDeSelectAll1(event) {
    //console.log("de select all 1")
   this.dropdownfilterMembers();
  }


  async getStatusInInterval() {
    try {
      let memberHmoID;
      this.eachContentList = [];
      let resultArrayOfMemberStatus = [];

      if (this.memberArrayList.length > 0) {
        this.memberArrayList.forEach((e) => {
          // setTimeout(async () => {
          //let eachMemberStatus = await
          resultArrayOfMemberStatus.push(
            this.epahafService
              .getUserCompleteStatus(e, this.username)
              .catch((err) => of(err.status))
          );
        });
        let response: any = await Promise.all(resultArrayOfMemberStatus);

        for (let i = 0; i < this.memberArrayList.length; i++) {
          let e = response[i].body;

          if (
            this.memberArrayList[i] === e[0].memberId
          ) {
            // parsedArray.forEach((memberData) => {
            // let e = JSON.parse(memberData._body).responseDatasArray[0];
            //if (e[0].memberStatus && e[0].memberStatus === "Completed") { //-- commenting as part of status changes
            if (e[0].memberStatus && e[0].memberStatus != 'Not Received') {
              let index = _.findIndex(
                this.memberArrayList,
                (x) => x === e[0].memberId
              );
              ////////console.log("Index and status :",index, status)
              this.memberArrayList.splice(index, 1);
              if (e[0].memberId) {
                memberHmoID = e[0].memberId;
              }
              let eachContent = {
                status: e[0].memberStatus,
                memberHmoID: memberHmoID,
              };
              this.eachContentList.push(eachContent);
            }
            // });
          }
        }

        let fromService = JSON.parse(
          this.secureStorage.getSecureInfoInLocalStorage('memberdetailsPdfData')
        );
        this.eachContentList.forEach((updateEach) => {
          //if (updateEach.status === "Completed") {
          if (updateEach.status != 'Not Received') {
            var index = _.findIndex(this.virtualLoadingMemberDetailData, {
              memberHmoID: updateEach.memberHmoID,
            });
            this.virtualLoadingMemberDetailData[index].status =
              updateEach.status;
            if (fromService) {
              var index2 = _.findIndex(fromService, {
                memberHmoID: updateEach.memberHmoID,
              });
              fromService[index2].status = updateEach.status;
              this.secureStorage.setSecureInfoInLocalStorage(
                'memberdetailsPdfData',
                JSON.stringify(fromService)
              );
            }
          }
        });
        // }, 1000);
      }
    } catch (e) {
      //////console.log(e);
    }
  }

  async getUploadStatus() {
    try {
      let memberHmoID;
      this.eachContentListUpload = [];
      let resultArrayOfMemberStatusUpload = [];

      if (this.memberArrayListUpload.length > 0) {
        this.memberArrayListUpload.forEach((e) => {
          resultArrayOfMemberStatusUpload.push(
            this.epahafService
              .getUserCompleteStatus(e, this.username)
              .catch((err) => of(err.status))
          );
        });
        let response: any = await Promise.all(resultArrayOfMemberStatusUpload);

        for (let i = 0; i < this.memberArrayListUpload.length; i++) {
          //let e = JSON.parse(response[i].body);
          let e = response[i].body;
          //let e = response;

          if (
            //this.memberArrayListUpload[i] === e[0].memberId && response[i].url.includes(e[0].memberId)) { //
            this.memberArrayListUpload[i] === e[0].memberId
          ) {
            //
            //if ((e[0].memberStatus && e[0].memberStatus != "Not Received" && e[0].memberStatus != "Provider feedback")) {
            if (e[0].memberStatus && e[0].memberStatus != 'Not Received') {
              let index = _.findIndex(
                this.memberArrayListUpload,
                (x) => x === e[0].memberId
              );
              ////////console.log("Index and status :",index, status)
              this.memberArrayListUpload.splice(index, 1);
              if (e[0].memberId) {
                memberHmoID = e[0].memberId;
              }
              let eachContentUpload = {
                status: e[0].memberStatus,
                memberHmoID: memberHmoID,
              };
              this.eachContentListUpload.push(eachContentUpload);
            }
            // });
          }
        }

        let fromService = JSON.parse(
          this.secureStorage.getSecureInfoInLocalStorage('memberdetailsPdfData')
        );
        this.eachContentListUpload.forEach((updateEach) => {
          //if (updateEach.status === "Completed") {
          //if (updateEach.status != "Not Received" && updateEach.status != "Provider feedback") {
          if (updateEach.status != 'Not Received') {
            var index = _.findIndex(this.virtualLoadingMemberDetailData, {
              memberHmoID: updateEach.memberHmoID,
            });
            this.virtualLoadingMemberDetailData[index].status =
              updateEach.status;
            if (fromService) {
              var index2 = _.findIndex(fromService, {
                memberHmoID: updateEach.memberHmoID,
              });
              fromService[index2].status = updateEach.status;
              this.secureStorage.setSecureInfoInLocalStorage(
                'memberdetailsPdfData',
                JSON.stringify(fromService)
              );
            }
          }
        });
        // }, 1000);
      }
    } catch (e) {
      //////console.log(e);
    }
  }

  // selectUnselectAll(event) {
  //   this.loadingDashboard = true;
  //   if (event.target.checked == true) {
  //     this.checkboxesSelect.forEach((element) => {
  //       element.nativeElement.checked = true;
  //     });
  //     this.selectedAllMember(event);
  //   } else {
  //     event.target.checked == false;
  //     this.checkboxesSelect.forEach((element) => {
  //       element.nativeElement.checked = false;
  //     });
  //     this.checkedList = [];
  //     this.counter = 0;
  //     this.notChecked = true;
  //     this.loadingDashboard = false;
  //   }
  // }

  selectUnselectAll(event) {
    this.selectedPdfObject = [];
    this.chunks = [];
    this.loadingDashboard = true;
    this.isSelectAllInProgress = true;
    if (event.target.checked == true) {
      this.checkboxesSelect.forEach((element) => {
        element.nativeElement.checked = true;
      });
      // Directly populate without calling selectedAllMember to avoid API calls
      if(this.selectedPahafStatus.length || this.searchInput) {
        this.selectedmemberdetailsPdfData = this.allFilterdData;
      } else {
        this.selectedmemberdetailsPdfData = this.memberdetailsPdfData;
      }
      this.chunks.push(this.selectedmemberdetailsPdfData);
      this.checkedList = this.selectedmemberdetailsPdfData;
      this.notChecked = false;
      this.loadingDashboard = false;
    } else {
      event.target.checked = false;
      this.checkboxesSelect.forEach((element) => {
        element.nativeElement.checked = false;
      });
      this.checkedList = [];
      this.selectedmemberdetailsPdfData = [];
      this.counter = 0;
      this.notChecked = true;
      this.loadingDashboard = false;
    }

    setTimeout(() => {
      this.isSelectAllInProgress = false;
    }, 0);
  }

  selectedAllMember(event?) {
    this.loadingDashboard = true;
    if (event.target.checked) {
      this.memberdetailsPdfData.map((element) => {
        this.checkedList.push(element);
        ////console.log("All memeber for checklist", this.checkedList);
      });
      this.notChecked = false;
      this.loadingDashboard = false;
    }
  }
  // async getMemberdetails(name, type?, searchedMember?) {
  //   // this.secureStorage.setSecureInfoInLocalStorage('dataSaved',"false");
  //   this.loadingDashboard = true;
  //   let temp = [];
  //   let memberArray;
  //   let reg = new RegExp(searchedMember, "gi");
  //   this.memberdetailsData = [];
  //   this.memberdetailsPdfData = [];
  //   this.virtualLoadingMemberDetailData = ["loading..."];
  //   this.signinService.getResult();
  //   //this.signinService.result.subscribe((fromService:any)=>{
  //   let fromService = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage("memberdetailsPdfData"));
  //   if (fromService) {
  //     if (fromService && fromService.length) {
  //       this.memberdetailsPdfData = fromService;
  //       if (this.memberdetailsPdfData && this.memberdetailsPdfData.length) {
  //         this.memberdetailsPdfData.map((data) => {
  //           // if (
  //           //   reg.test(data.memberHmoID) ||
  //           //   reg.test(data.memberFirstName + data.memberLastName) ||
  //           //   reg.test(data.pcpName)
  //           // ) {
  //           this.memberdetailsData.push(data);

  //           if (temp && temp.length <= 49) {
  //             temp.push(data);
  //           }
  //           //}
  //         });
  //         setTimeout(() => {
  //           if (temp && temp.length) {
  //             this.virtualLoadingMemberDetailData = temp;
  //             //this.copymemberDetailsData = this.virtualLoadingMemberDetailData;
  //             this.copymemberDetailsData = this.memberdetailsData;
  //             this.loadingDashboard = false;
  //           } else {
  //             this.virtualLoadingMemberDetailData = [
  //               "No records found for the searched criteria",
  //             ];
  //             this.loadingDashboard = false;
  //           }
  //         }, 20);
  //       }
  //     } else {
  //       this.loadingDashboard = false;
  //       // this.memberdetailsData = ["No Data found "];
  //       // this.virtualLoadingMemberDetailData = ["No Data found "];
  //       // this.memberdetailsPdfData = ["No Data found "];
  //     }

  //     this.secureStorage.setSecureInfoInSessionlStorage(
  //       "resDataLength",
  //       JSON.stringify(this.memberdetailsData.length)
  //     );
  //     if (this.memberdetailsData.length >= 49) {
  //       $("#displays").show();
  //     } else {
  //       $("#displays").hide();
  //     }

  //     this.loadingDashboard = false;
  //   } else if (this.secureStorage.getSecureInfoInLocalStorage("dataSaved") === "false") {
  //     this.loadingDashboard = false;
  //     this.memberdetailsData = ["No Data found "];
  //     this.virtualLoadingMemberDetailData = ["No Data found  "];
  //     this.memberdetailsPdfData = ["No Data found "];
  //   } else {
  //     this.virtualLoadingMemberDetailData = ["loading..."];
  //   }
  //   // })
  // }
  //         //   reg.test(data.memberHmoID) ||

  //         //   reg.test(data.memberHmoID) ||

  async getMemberdetails(name, searchedMember?) {
    this.loadingDashboard = true;
    let temp = [];
    this.memberdetailsData = [];
    this.memberdetailsPdfData = [];
    this.virtualLoadingMemberDetailData = ['loading...'];

    // let statusRes = await this.epahafService.getUserCompleteStatus();

    // let responseData: any;
    // if (statusRes._body) {
    //   responseData = JSON.parse(statusRes._body);
    //   memberArray = responseData.responseDatasArray;
    // }

    // this.epahafService.getNewMemberdatasChart(name).subscribe(
    //   (Response) => {

    //       let ResponseData: any;
    //       ResponseData = Response.responseDatasArray;
    //       if (ResponseData.length > 0) {
    //         ResponseData.map((element, index) => {
    //           let obj: any = {};
    //           obj.userName = element.userName;
    //           obj.memberHmoID = element.memberId;
    //           obj.memberFirstName = element.memberName;
    //           obj.memberDOB = this.convertDateFormat(element.memberDOB);
    //           obj.pcpName = element.pcpName;
    //           obj.pcpId = element.pcpId;
    //           obj.memberId = element.memberId;
    //           //obj.memberStatusCount = element.memberStatusCount;
    //           obj.memberContactNumber = this.formatPhoneNumber(element.memberPhone);
    //           obj.index = index;
    //           obj.total = '';
    //           obj.status = element.memberStatus;
    //           obj.conditionCount = element.conditionCount;
    //           obj.statusDate = element.statusDate;
    //           obj.mode = element.mode;
    //           //obj.measureCount = element.measureCount;
    //           obj.total = 0;
    //           obj.denialReason = element.denialReason;
    //           this.memberdetailsPdfData.push(obj);
    //           //  temp.push(obj);
    //         });
    //         ////////console.log("memberdetailsPdfData :",this.memberdetailsPdfData)
    //         this.epahafService.setEpahafMemberData(this.memberdetailsPdfData);
    //         if (this.memberdetailsPdfData && this.memberdetailsPdfData.length) {
    //           this.memberdetailsPdfData.map((data) => {
    //             this.memberdetailsData.push(data);

    //             if (temp && temp.length <= 49) {
    //               temp.push(data);
    //             }
    //             //}
    //           });
    //           setTimeout(() => {
    //             if (temp && temp.length) {
    //               this.virtualLoadingMemberDetailData = temp;
    //               this.copymemberDetailsData = this.memberdetailsData;
    //               this.loadingDashboard = false;
    //             } else {
    //               this.virtualLoadingMemberDetailData = [
    //                 "No records found for the searched criteria",
    //               ];
    //               this.loadingDashboard = false;
    //             }
    //           }, 20);
    //         }
    //       } else {
    //         this.loadingDashboard = false;
    //         this.memberdetailsData = ["No Data found "];
    //         this.virtualLoadingMemberDetailData = ["No Data found "];
    //         this.memberdetailsPdfData = ["No Data found "];
    //       }

    //       this.secureStorage.setSecureInfoInSessionlStorage(
    //         "resDataLength",
    //         JSON.stringify(this.memberdetailsData.length)
    //       );
    //       if (this.memberdetailsData.length >= 49) {
    //         $("#displays").show();
    //       } else {
    //         $("#displays").hide();
    //       }

    //     //this.notChecked = true;
    //   },
    //   () => {
    //     this.loadingDashboard = false;
    //     // this.notChecked = true;
    //     this.memberdetailsData = ["No Data found "];
    //     this.virtualLoadingMemberDetailData = ["No Data found "];
    //     this.memberdetailsPdfData = ["No Data found"];
    //   }
    // );

    this.epahafService.getNewMemberdatasChart(name).subscribe(
      (Response) => {
        let ResponseData: any;
        ResponseData = Response.responseDatasArray;
        //console.log("ResponseData :",ResponseData)
        if (ResponseData && ResponseData.length > 0) {
          ResponseData.map((element, index) => {
            let obj: any = {};
            obj.userName = element.userName;
            obj.memberHmoID = element.memberId;
            obj.memberFirstName = element.memberName;
            // obj.memberLastName = element.memberLastName;
            obj.memberDOB = this.convertDateFormat(element.memberDOB);
            obj.pcpName = element.pcpName;
            obj.pcpId = element.pcpId;
            //obj.memberId = element.memberUid;
            //obj.memberStatusCount = element.memberStatusCount;
            obj.memberContactNumber = element.memberPhone;
            //obj.memnerUid = element.member_ALTERNATE_ID_UID;
            obj.index = index;
            obj.total = '';
            obj.status = element.memberStatus;
            obj.conditionCount = element.conditionCount;
            obj.statusDate = element.statusDate;
            obj.mode = element.mode;
            obj.refreshStatus = element.refreshStatus;
            // this.getQmDashboardMemberData(this.uniquePcpList[element.PRPR_ID]).then((res) => {
            //   //console.log('ress :', res)
            // })
            //obj.measureCount = element.measureCount;
            //obj.total = (element.conditionCount + this.getCount(element.PRPR_ID,element.memberHmoID));
            obj.total = 0;
            obj.denialReason = element.denialReason;
            ////console.log("total measures-- :",this.getCount(element.PRPR_ID,element.memberHmoID))
            this.memberdetailsPdfData.push(obj);
            //  temp.push(obj);
          });
          //console.log("memberdetailsPdfData :",this.memberdetailsPdfData)
          this.epahafService.setEpahafMemberData(this.memberdetailsPdfData);
          if (this.memberdetailsPdfData && this.memberdetailsPdfData.length) {
            this.memberdetailsPdfData.map((data) => {
              this.memberdetailsData.push(data);

              if (temp && temp.length <= 49) {
                temp.push(data);
              }
              //}
            });
            setTimeout(() => {
              if (temp && temp.length) {
                this.virtualLoadingMemberDetailData = temp;
                this.copymemberDetailsData = this.memberdetailsData;
                this.loadingDashboard = false;
                ////console.log("virtualLoadingMemberDetailData ---:",this.virtualLoadingMemberDetailData);
              } else {
                this.virtualLoadingMemberDetailData = [
                  'No records found for the searched criteria',
                ];
                this.loadingDashboard = false;
              }
            }, 20);
          }
        } else {
          this.loadingDashboard = false;
          this.memberdetailsData = ['No Data found '];
          this.virtualLoadingMemberDetailData = ['No Data found '];
          this.memberdetailsPdfData = ['No Data found '];
        }

        this.secureStorage.setSecureInfoInSessionlStorage(
          'resDataLength',
          JSON.stringify(this.memberdetailsData.length)
        );
        if (this.memberdetailsData.length >= 49) {
          const displaysElement = document.getElementById('displays');
          if (displaysElement) {
            displaysElement.style.display = 'block';
          }
        } else {
          const displaysElement = document.getElementById('displays');
          if (displaysElement) {
            displaysElement.style.display = 'none';
          }
        }

        //this.notChecked = true;
      },
      (err) => {
        this.loadingDashboard = false;
        // this.notChecked = true;
        this.memberdetailsData = ['No Data found '];
        this.virtualLoadingMemberDetailData = ['No Data found '];
        this.memberdetailsPdfData = ['No Data found'];
        if ([500].includes(err.status)) {
          this.displayErrMsg = this.errMsg500;
          this.openModal('errorGeneratePdf');
        } else if ([504].includes(err.status)) {
          this.displayErrMsg = this.errMsg504;
          this.openModal('errorGeneratePdf');
        } else {
          this.displayErrMsg = this.errMsg500;
          this.openModal('errorGeneratePdf');
        }
      }
    );
  }
  errorModal() {
    this.closeModal('errorGeneratePdf');
  }
  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  }

  // filterMembers(event: any, data?) {
  //   //////console.log("filter mem :",event,data)
  //   let reg = new RegExp(this.searchInput, "gi");
  //   //////console.log("this.searchInput :",this.searchInput)
  //   this.loadingDashboard = true;
  //   this.getLatest = [];
  //   this.checkedList = [];
  //   let tempFilter = [];
  //   let tempFilter2 = [];
  //   if (data) {
  //     this.allCompleteDataforFilter = data;
  //     this.allPendingDataforFilter = data;
  //     //////console.log("this.allCompleteDataforFilter -- this.allPendingDataforFilter = data:",this.allCompleteDataforFilter,this.allPendingDataforFilter = data)
  //   }

  //   if (
  //     !this.completeFlag &&
  //     !this.incompleteFlag &&
  //     this.allfilterFlag &&
  //     !this.completeFlag &&
  //     !this.incompleteFlag
  //   ) {
  //     this.memberdetailsData.map((data) => {
  //       ////////console.log("data.memberHmoID --:,data.memberFirstName---:,data.pcpName--:",data.memberHmoID,data.memberFirstName,data.pcpName)
  //       if (
  //         this.searchInput &&
  //         (reg.test(data.memberHmoID) ||
  //           reg.test(data.memberFirstName) ||
  //           reg.test(data.pcpName.replace(/\s+/g, ' ')))
  //       ) {
  //         tempFilter2.push(data);
  //         ////////console.log("1--- tempFilter2 :",tempFilter2)
  //       } else {
  //         tempFilter.push(data);
  //         ////////console.log("tempFilter --:",tempFilter)
  //       }
  //     });

  //     if (this.searchInput && tempFilter2.length) {
  //       if (tempFilter2.length > 50) {
  //         this.virtualLoadingMemberDetailData = tempFilter2.slice(0, 49);
  //         $("#displays").show();
  //       } else {
  //         this.virtualLoadingMemberDetailData = tempFilter2;
  //         $("#displays").hide();
  //       }
  //     } else if (!this.searchInput && tempFilter.length) {
  //       if (tempFilter.length > 50) {
  //         this.virtualLoadingMemberDetailData = tempFilter.slice(0, 49);
  //         $("#displays").show();
  //       } else {
  //         this.virtualLoadingMemberDetailData = tempFilter;
  //         $("#displays").hide();
  //       }
  //     } else {
  //       this.virtualLoadingMemberDetailData = [
  //         "No records found for the searched criteria",
  //       ];

  //       $("#displays").hide();
  //     }

  //     this.loadingDashboard = false;
  //   } else if (this.completeFlag === true) {
  //     if (this.allCompleteDataforFilter.length > 0) {
  //       this.allCompleteDataforFilter.map((data) => {
  //         if (
  //           this.searchInput &&
  //           (reg.test(data.memberHmoID) ||
  //             reg.test(data.memberFirstName) ||
  //             reg.test(data.pcpName))
  //         ) {
  //           tempFilter2.push(data);
  //         } else {
  //           tempFilter.push(data);
  //         }
  //       });

  //       if (this.searchInput && tempFilter2.length) {
  //         if (tempFilter2.length > 50) {
  //           this.virtualLoadingMemberDetailData = tempFilter2.slice(0, 49);
  //           $("#displays").show();
  //         } else {
  //           this.virtualLoadingMemberDetailData = tempFilter2;
  //           $("#displays").hide();
  //         }
  //       } else if (!this.searchInput && tempFilter.length) {
  //         if (tempFilter.length > 50) {
  //           this.virtualLoadingMemberDetailData = tempFilter.slice(0, 49);
  //           $("#displays").show();
  //         } else {
  //           this.virtualLoadingMemberDetailData = tempFilter;
  //           $("#displays").hide();
  //         }
  //       } else {
  //         this.virtualLoadingMemberDetailData = [
  //           "No records found for the searched criteria",
  //         ];

  //         $("#displays").hide();
  //       }

  //       this.loadingDashboard = false;
  //     } else {
  //       this.completeFlag = false;
  //       this.loadingDashboard = false;
  //     }
  //   } else if (this.incompleteFlag === true) {
  //     if (this.allPendingDataforFilter.length > 0) {
  //       this.allPendingDataforFilter.map((data) => {
  //         if (
  //           this.searchInput &&
  //           (reg.test(data.memberHmoID) ||
  //             reg.test(data.memberFirstName) ||
  //             reg.test(data.pcpName))
  //         ) {
  //           tempFilter2.push(data);
  //         } else {
  //           tempFilter.push(data);
  //         }
  //       });

  //       if (this.searchInput && tempFilter2.length) {
  //         if (tempFilter2.length > 50) {
  //           this.virtualLoadingMemberDetailData = tempFilter2.slice(0, 49);
  //           $("#displays").show();
  //         } else {
  //           this.virtualLoadingMemberDetailData = tempFilter2;
  //           $("#displays").hide();
  //         }
  //       } else if (!this.searchInput && tempFilter.length) {
  //         if (tempFilter.length > 50) {
  //           this.virtualLoadingMemberDetailData = tempFilter.slice(0, 49);
  //           $("#displays").show();
  //         } else {
  //           this.virtualLoadingMemberDetailData = tempFilter;
  //           $("#displays").hide();
  //         }
  //       } else {
  //         this.virtualLoadingMemberDetailData = [
  //           "No records found for the searched criteria",
  //         ];

  //         $("#displays").hide();
  //       }

  //       this.loadingDashboard = false;
  //     } else {
  //       this.incompleteFlag = false;
  //       this.loadingDashboard = false;
  //     }
  //   }
  //   //this.allFilterdData = tempFilter2;
  // }

  //Changed FilterMember function as part of PAHAF Dashboard changes:
  filterMembers(event) {
    let reg = new RegExp(this.searchInput, 'gi');
    ////////console.log("this.searchInput :",this.searchInput)
    this.loadingDashboard = true;
    this.getLatest = [];
    this.checkedList = [];
    let tempFilter = [];
    let tempFilter2 = [];
    this.selectedPdfObject = [];
    this.counter = 0;
    this.notChecked = true;

    //if (!this.allFilterdData) {
    if (this.selectedPahafStatus.length === 0) {
      this.memberdetailsData.map((data) => {
        ////////console.log("data.memberHmoID --:,data.memberFirstName---:,data.pcpName--:",data.memberHmoID,data.memberFirstName,data.pcpName)
        if (
          this.searchInput &&
          (reg.test(data.memberHmoID) ||
            reg.test(data.memberFirstName) ||
            reg.test(data.pcpName.replace(/\s+/g, ' ')))
        ) {
          tempFilter2.push(data);
        } else {
          tempFilter.push(data);
        }
      });

      if (this.searchInput && tempFilter2.length) {
        if (tempFilter2.length > 50) {
          this.virtualLoadingMemberDetailData = tempFilter2.slice(0, 49);
          const displaysElement = document.getElementById('displays');
          if (displaysElement) {
            displaysElement.style.display = 'block';
          }
        } else {
          this.virtualLoadingMemberDetailData = tempFilter2;
          const displaysElement = document.getElementById('displays');
          if (displaysElement) {
            displaysElement.style.display = 'none';
          }
        }
      } else if (!this.searchInput && tempFilter.length) {
        if (tempFilter.length > 50) {
          this.virtualLoadingMemberDetailData = tempFilter.slice(0, 49);
          const displaysElement = document.getElementById('displays');
          if (displaysElement) {
            displaysElement.style.display = 'block';
          }
        } else {
          this.virtualLoadingMemberDetailData = tempFilter;
          const displaysElement = document.getElementById('displays');
          if (displaysElement) {
            displaysElement.style.display = 'none';
          }
        }
      } else {
        this.virtualLoadingMemberDetailData = [
          'No records found for the searched criteria',
        ];

        const displaysElement = document.getElementById('displays');
if (displaysElement) {
  displaysElement.style.display = 'none';
}
      }
      this.allFilterdData = tempFilter2;
      this.loadingDashboard = false;
    } else {
      this.dropdownfilterMembers();
      this.loadingDashboard = false;
    }

    //this.allFilterdData = tempFilter2;
  }

  dropdownfilterMembers() {
    let dptempFilter = [];
    let dptempFilter2 = [];
    let reg = new RegExp(this.searchInput, 'gi');
    let filteredItem: any = [];
    let filteredItemWithRefresh: any = [];
    let filteredItemWithOutRefresh: any = [];
    let filterRefresh: any =[]
    this.loadingDashboard = true;
    if (this.selectedPahafStatus.length !== 0) {
      let result = this.selectedPahafStatus.filter((item) => {
        this.memberdetailsData.filter((element) => {
          ////console.log("printing element :",element,element.status)
          if (element.status) {
            if (element.status.toLowerCase() === item.itemName.toLowerCase()) {
              filterRefresh.push(element);
            }
          }
        });
      });
//console.log("this.selectedPahafStatusRefresh.length--:",this.selectedPahafStatusRefresh.length)
      if(this.selectedPahafStatusRefresh.length !== 0) {
//console.log("inside this.selectedPahafStatusRefresh.length")
        let refreshResult = this.selectedPahafStatusRefresh.filter((itemRefresh) => {
          filterRefresh.filter((sts: any) => {
            if(sts.refreshStatus) {
              if (sts.refreshStatus.toLowerCase() === itemRefresh.itemName.toLowerCase()) {
                filteredItemWithRefresh.push(sts);
            }
          }
          })
        })

        filteredItem = filteredItemWithRefresh;
      } else {
        //console.log(" outside ",filterRefresh)
        filterRefresh.filter((element: any) => {
          if (element.status) {
              filteredItemWithOutRefresh.push(element);
          }
        })
        filteredItem = filteredItemWithOutRefresh;
      }

      //console.log("filteredItem--:",filteredItem)

      if (filteredItem.length) {
        if (this.searchInput) {
          ////console.log("in dropdowwn this.searchInput :",this.searchInput)
          filteredItem.map((data) => {
            if (
              this.searchInput &&
              (reg.test(data.memberHmoID) ||
                reg.test(data.memberFirstName) ||
                reg.test(data.pcpName.replace(/\s+/g, ' ')))
            ) {
              dptempFilter2.push(data);
            } else {
              dptempFilter.push(data);
            }
          });

          if (this.searchInput && dptempFilter2.length) {
            filteredItem = dptempFilter2;
            if (dptempFilter2.length > 50) {
              this.virtualLoadingMemberDetailData = dptempFilter2.slice(0, 49);
              const displaysElement = document.getElementById('displays');
              if (displaysElement) {
                displaysElement.style.display = 'block';
              }
            } else {
              this.virtualLoadingMemberDetailData = dptempFilter2;
              const displaysElement = document.getElementById('displays');
              if (displaysElement) {
                displaysElement.style.display = 'none';
              }
            }
          } else if (!this.searchInput && dptempFilter.length) {
            filteredItem = dptempFilter;
            if (dptempFilter.length > 50) {
              this.virtualLoadingMemberDetailData = dptempFilter.slice(0, 49);
              const displaysElement = document.getElementById('displays');
              if (displaysElement) {
                displaysElement.style.display = 'block';
              }
            } else {
              this.virtualLoadingMemberDetailData = dptempFilter;
              const displaysElement = document.getElementById('displays');
              if (displaysElement) {
                displaysElement.style.display = 'none';
              }
            }
            //filteredItem = dptempFilter2;
          } else {
            //filteredItem = dptempFilter2;
            this.virtualLoadingMemberDetailData = [
              'No records found for the searched criteria',
            ];
            const displaysElement = document.getElementById('displays');
            if (displaysElement) {
              displaysElement.style.display = 'none';
            }
          }
        } else {
          if (filteredItem.length > 50) {
            this.virtualLoadingMemberDetailData = filteredItem.slice(0, 49);
            const displaysElement = document.getElementById('displays');
            if (displaysElement) {
              displaysElement.style.display = 'block';
            }
          } else {
            this.virtualLoadingMemberDetailData = filteredItem;
            const displaysElement = document.getElementById('displays');
            if (displaysElement) {
              displaysElement.style.display = 'none';
            }
          }
        }
      } else {
        this.virtualLoadingMemberDetailData = [
          'No records found for the searched criteria',
        ];
        const displaysElement = document.getElementById('displays');
        if (displaysElement) {
          displaysElement.style.display = 'none';
        }
      }

      if (this.selectedPahafStatusRefresh.length !== 0) {
        this.allFilterdData = filteredItemWithRefresh;

      } 
      else {
        this.allFilterdData = filteredItemWithOutRefresh
      }
      
      //console.log("allFilterdData---:",this.allFilterdData);

    } else if (this.selectedPahafStatus.length === 0 && this.searchInput) {
      this.filterMembers(this.searchInput);
    } else {
      this.virtualLoadingMemberDetailData = [
        'No records found for the searched criteria',
      ];
      const displaysElement = document.getElementById('displays');
      if (displaysElement) {
        displaysElement.style.display = 'none';
      }
    }
    //this.allFilterdData = filteredItem;
    this.loadingDashboard = false;
    // this.allFilterdData = [];
  }

  onSortClick(event:Event,field:string){
    var cons=event;
    this.sortDirectives.forEach((directive)=>{
     if(directive.sortField=== field){
      this.lastSortField=directive.sortField;
      this.lastSortOrder=directive.sortOrder
      directive.onClick();
     } 
   
    });
  }

 
 

  loadmoreData() {
 
    this.loadingDashboard = true;
    let loadMoreData = [];
    let startIndex = this.virtualLoadingMemberDetailData.length;
    let endIndex = this.virtualLoadingMemberDetailData.length + 50;
    if (this.allFilterdData.length > 0) {
      if (endIndex < this.allFilterdData.length) {
        for (let i = startIndex; i < endIndex; i++) {
          loadMoreData.push(this.allFilterdData[i]);
        }
      } else {
        for (
          let i = this.virtualLoadingMemberDetailData.length;
          i < this.allFilterdData.length;
          i++
        ) {
          loadMoreData.push(this.allFilterdData[i]);
        }
      }

      this.virtualLoadingMemberDetailData =
        this.virtualLoadingMemberDetailData.concat(loadMoreData);
      if (
        this.virtualLoadingMemberDetailData.length ===
        this.allFilterdData.length
      ) {
        const displaysElement = document.getElementById('displays');
        if (displaysElement) {
          displaysElement.style.display = 'none';
        }
      }
    }
    //  else if (this.allPendingDataforFilter.length > 0 && !this.searchInput) {
    //   if (endIndex < this.allPendingDataforFilter.length) {
    //     for (let i = startIndex; i < endIndex; i++) {
    //       loadMoreData.push(this.allPendingDataforFilter[i]);
    //     }
    //   } else {
    //     for (
    //       let i = this.virtualLoadingMemberDetailData.length;
    //       i < this.allPendingDataforFilter.length;
    //       i++
    //     ) {
    //       loadMoreData.push(this.allPendingDataforFilter[i]);
    //     }
    //   }

    //   this.virtualLoadingMemberDetailData =
    //     this.virtualLoadingMemberDetailData.concat(loadMoreData);
    //   if (
    //     this.virtualLoadingMemberDetailData.length ===
    //     this.allPendingDataforFilter.length
    //   ) {
    //     $("#displays").hide();
    //   }
    // }
    // else if (this.allCompleteDataforFilter.length > 0 && !this.searchInput) {
    //   if (endIndex < this.allCompleteDataforFilter.length) {
    //     for (let i = startIndex; i < endIndex; i++) {
    //       loadMoreData.push(this.allCompleteDataforFilter[i]);
    //     }
    //   } else {
    //     for (
    //       let i = this.virtualLoadingMemberDetailData.length;
    //       i < this.allCompleteDataforFilter.length;
    //       i++
    //     ) {
    //       loadMoreData.push(this.allCompleteDataforFilter[i]);
    //     }
    //   }

    //   this.virtualLoadingMemberDetailData =
    //     this.virtualLoadingMemberDetailData.concat(loadMoreData);
    //   if (
    //     this.virtualLoadingMemberDetailData.length ===
    //     this.allCompleteDataforFilter.length
    //   ) {
    //     $("#displays").hide();
    //   }
    // }
    else {
      if (endIndex < this.memberdetailsData.length) {
        for (let i = startIndex; i < endIndex; i++) {
          loadMoreData.push(this.memberdetailsData[i]);
        }
      } else {
        for (
          let i = this.virtualLoadingMemberDetailData.length;
          i < this.memberdetailsData.length;
          i++
        ) {
          loadMoreData.push(this.memberdetailsData[i]);
        }
      }

    this.virtualLoadingMemberDetailData =
      this.virtualLoadingMemberDetailData.concat(loadMoreData);
      if (
        this.virtualLoadingMemberDetailData.length ===
        this.memberdetailsData.length
      ) {
        const displaysElement = document.getElementById('displays');
        if (displaysElement) {
          displaysElement.style.display = 'none';
        }
      }
    
    }
    
    this.loadingDashboard = false;
    this.reapplySorting();

  }

  reapplySorting(){
    this.sortDirectives.forEach((directive)=>{
      if(this.lastSortField && this.lastSortOrder && directive.sortField === this.lastSortField){
       directive.sortField=this.lastSortField;
       directive.sortOrder=this.lastSortOrder;
       directive.appSortCustom=this.virtualLoadingMemberDetailData;
       directive.onClick();
      } 
    
     });
    //console.log("after reapplySorting data", this.virtualLoadingMemberDetailData);
 
   }

  ngAfterViewInit() {}
  clickedMemberRoster(memberRosterValue) {
    if (memberRosterValue) {
      this.generateButtonFlag = false;
      this.disableDropdown = false;
      this.selectedids = '';
    }
  }
  clickedPCPValues(pcps) {
    if (pcps) {
      this.disableDropdown = true;
      this.generateButtonFlag = true;
      try {
        this.selectedids = ' ';
        let duplicates = [];
        this.providerIds = [];
        this.epahafService.getProviderBasicDetails().subscribe((data) => {
          let uniqueids = [];
          const providerDetails = data;
          if (providerDetails && providerDetails.length > 0) {
            providerDetails.map((siteUser) => {
              if (
                siteUser &&
                siteUser.providers &&
                siteUser.providers.length > 0
              ) {
                siteUser.providers.map((element) => {
                  if (
                    _.findIndex(duplicates, {
                      name: element.name,
                      address: element.address,
                    }) == -1
                  ) {
                    duplicates.push({
                      name: element.name,
                      address: element.address,
                    });
                    uniqueids.push({
                      name: element.name,
                      code: element.providerId,
                      regionCode: element.regionCode,
                      prv_id: element.providerId + element.regionCode,
                      address: element.address.slice(5).split(/[()]/)[0],
                    });
                  }
                });
              }
            });
            setTimeout(() => {
              this.providerIds = _.sortBy(uniqueids, ['name', 'address']);
            }, 100);
          }
        });
      } catch (e) {
        //////console.log(e);
        this.providerIds = ['no PCP found'];
      }
    }
  }
  onPcpChange(event) {
    this.generateButtonFlag = false;
    this.pcpDocList = [];
    this.errorForCriteria = false;
    this.generateUnsubmittedDoc = true;
    try {
      const kplv = [
        {
          value: event.target.value,
          //value: "Chart",
          key: 'PCPID',
        },
        { key: 'Status', value: 'Pending' },
        {
          key: 'Year',
          value: new Date().getFullYear(),
        },
      ];
      let docId, docCode, memberId, allDoc, createdDate, docTitle, docType;

      this.epahafService.listofepahafDoc(kplv).subscribe(
        (epahafDocs: any) => {
          if (epahafDocs) {
            let docBody = epahafDocs;
            ////////console.log("docBody", docBody);
            if (
              docBody.keyValuePairListWrapperlist &&
              docBody.keyValuePairListWrapperlist.length > 0
            ) {
              allDoc = this.generateList(docBody.keyValuePairListWrapperlist);
            }
          }

          ////////console.log("allDocPcp", allDoc);
          if (allDoc && Array.isArray(allDoc) && allDoc.length > 0) {
            allDoc.forEach((ele: any) => {
              if (ele.type) {
                docType = ele.type;
              }
              if (ele.Id) {
                docId = ele.Id;
              }
              if (ele.DocumentClass) {
                docCode = ele.DocumentClass;
              }
              if (ele.memberid) {
                memberId = ele.memberid;
              }
              if (ele.CreatedDate) {
                //let forDate = new Date(ele.CreatedDate)
                createdDate = ele.CreatedDate;
              }
              if (ele.DocumentTitle) {
                docTitle = ele.DocumentTitle;
              }
              // if(ele.DocumentTitle){
              //   docExtension = ele.DocumentTitle.match(patt1)[1]
              // }
              let docContent = {
                docId: docId,
                docCode: docCode,
                memberId: memberId,
                createdDate: createdDate,
                docTitle: docTitle,
                docType: docType,
                // docExtension : docExtension
              };

              this.pcpDocList.push(docContent);
              ////////console.log("pcplist", this.pcpDocList);
            });
          }
        },
        () => {
          this.loadingDashboard = false;
        }
      );
    } catch (e) {}
  }
  generateRosterDoc() {
    //  / this.loadingDashboard = true;
    try {
      if (!this.generateUnsubmittedDoc && !this.selectedids) {
        // this.ngProgress.start();
        this.rows=[];
        let name;
        var frontdoc = new jsPDF("l", "pt");
        this.virtualLoadingMemberDetailData.forEach(async (member) => {
          name = member.memberFirstName;
          this.mainHead = [
            [
              'PCP',
              'Member ID',
              'Member Name',
              'Date of Birth',
              'Member Contact No.',
              'Pahaf Status',
              'Refresh Status',
              'Notes',
            ],
          ];
          //var rows = [];
          var temp = [
            member.pcpName,
            member.memberHmoID,
            name,
            member.memberDOB,
            member.memberContactNumber,
            member.status ? member.status : 'none',
            member.refreshStatus ? member.refreshStatus : 'none',
            ' ',
          ];
          this.rows.push(temp);
        });

        const pageWidth = frontdoc.internal.pageSize.getWidth 
        ? frontdoc.internal.pageSize.getWidth() 
        : frontdoc.internal.pageSize.width;

        const marginLeft = 30;
        const marginRight = 10;
        const printableWidth = pageWidth - marginLeft - marginRight;

        frontdoc.setFontSize(16);
        frontdoc.text(
          'PAHAF Member Details',
          marginLeft, // Matches table start perfectly
          35
        );


        autoTable(frontdoc,{
           // Places table below the text title
          head: this.mainHead,
          body: this.rows,
          columnStyles: {
            // Percentages must total 100% of printableWidth
            0: { cellWidth: printableWidth * 0.16 }, // ~16%
            1: { cellWidth: printableWidth * 0.12 }, // ~12%
            2: { cellWidth: printableWidth * 0.14 }, // ~14%
            3: { cellWidth: printableWidth * 0.12 }, // ~12%
            4: { cellWidth: printableWidth * 0.13 }, // ~13%
            5: { cellWidth: printableWidth * 0.10 }, // ~10%
            6: { cellWidth: printableWidth * 0.10 }, // ~10%
            7: { cellWidth: printableWidth * 0.13 }, // ~13%
          },    
            margin: { left: marginLeft, right: marginRight },
          theme: 'grid',
          //showHead:'firstPage',
          headStyles: { fillColor: '#23499E', halign: 'center' },
          bodyStyles: { valign: 'top', halign: 'center' },
          startY: 60,
          willDrawCell: function () {},
        });

        const pageCount = frontdoc.internal.pages.length;
        for (var i = 1; i <= pageCount; i++) {
          frontdoc.setPage(i);
          frontdoc.setFontSize(10); // optional
          frontdoc.text(
            'Page ' + String(i) + ' of ' + String(pageCount),
            frontdoc.internal.pageSize.width / 2 - 20,
            frontdoc.internal.pageSize.height - 20
          );
          frontdoc.text(
            'Generated: ' + this.todaydate(),
            frontdoc.internal.pageSize.width - 140,
            frontdoc.internal.pageSize.height - 20
          );
        }
        // var lastPage = frontdoc.internal.getNumberOfPages();
        // frontdoc.deletePage(lastPage);
        this.loadingDashboard = false;
        frontdoc.save(
          'PAHAFDocument' + this.todaydateWithoutSymbols() + '.pdf'
        );
        this.rows = [];
        this.mainHead = [];
        this.counter = 0;
        this.notChecked = true;
        // this.ngProgress.done();

        this.unselectFlag = false;
      } else {
        ////////console.log(this.pcpDocList);
        if (this.pcpDocList.length > 0) {
          this.pcpDocList.forEach((e) => {
            this.getDocument(e);
          });
          this.generateUnsubmittedDoc = false;
        } else {
          this.errorForCriteria = true;
          this.generateUnsubmittedDoc = false;
        }
      }
    } catch (errror) {}
  }
  // clickedStatus(statusValue) {
  //   let statusFormats = { ALL: 1, complete: 2, incomplete: 3, noPahaf: 4 };
  //   let temp = [];
  //   this.virtualLoadingMemberDetailData = [];
  //   this.allCompleteDataforFilter = [];
  //   this.allPendingDataforFilter = [];
  //   this.pendingData = [];
  //   this.subMittedData = [];
  //   try {
  //     if (statusValue == statusFormats.complete) {
  //       this.statusType = true;
  //       this.completeFlag = true;
  //       this.loadingDashboard = true;
  //       let completeGridData = this.copymemberDetailsData.filter((x) => {
  //         return x.status == "Completed";
  //       });
  //       completeGridData.map((data) => {
  //         if (temp && temp.length <= 49) {
  //           temp.push(data);
  //         }
  //       });

  //       setTimeout(() => {
  //         if (temp && temp.length) {
  //           this.virtualLoadingMemberDetailData = temp.filter((x) => {
  //             return x.status == "Completed";
  //           });

  //           this.subMittedData = this.copymemberDetailsData.filter((x) => {
  //             return x.status == "Completed";
  //           });
  //           if (this.virtualLoadingMemberDetailData.length) {
  //             if (this.searchInput) {
  //               this.incompleteFlag = false;
  //               this.allfilterFlag = false;
  //               this.allCompleteDataforFilter = this.subMittedData;
  //               this.loadingDashboard = false;
  //               this.filterMembers(
  //                 this.searchInput,
  //                 this.allCompleteDataforFilter
  //               );
  //             } else {
  //               this.allCompleteDataforFilter = this.subMittedData;
  //               this.loadingDashboard = false;
  //             }
  //           }
  //         }
  //         if (this.virtualLoadingMemberDetailData.length > 49) {
  //           $("#displays").show();
  //         } else if (this.virtualLoadingMemberDetailData.length === 0) {
  //           this.virtualLoadingMemberDetailData = ["No records Found"];
  //           $("#displays").hide();
  //         } else {
  //           $("#displays").hide();
  //         }
  //       }, 10);
  //       this.loadingDashboard = false;
  //     } else if (statusValue == statusFormats.incomplete) {
  //       this.statusType = true;
  //       this.loadingDashboard = true;
  //       this.incompleteFlag = true;
  //       let incompleteGridData = this.copymemberDetailsData.filter((x) => {
  //         return x.status == "Not Completed";
  //       });
  //       incompleteGridData.map((data) => {
  //         if (temp && temp.length <= 49) {
  //           temp.push(data);
  //         }
  //       });
  //       setTimeout(() => {
  //         if (temp && temp.length) {
  //           // this.virtualLoadingMemberDetailData = temp;

  //           // }
  //           this.virtualLoadingMemberDetailData = temp.filter((x) => {
  //             return x.status == "Not Completed";
  //           });

  //           this.pendingData = this.copymemberDetailsData.filter((x) => {
  //             return x.status == "Not Completed";
  //           });
  //           if (this.pendingData.length) {
  //             if (this.searchInput) {
  //               this.completeFlag = false;
  //               this.allfilterFlag = false;
  //               this.allPendingDataforFilter = this.pendingData;
  //               this.loadingDashboard = false;
  //               this.filterMembers(
  //                 this.searchInput,
  //                 this.allPendingDataforFilter
  //               );
  //             } else {
  //               this.allPendingDataforFilter = this.pendingData;
  //               this.loadingDashboard = false;
  //             }
  //           }
  //         }

  //         if (this.virtualLoadingMemberDetailData.length > 49) {
  //           $("#displays").show();
  //         } else if (this.virtualLoadingMemberDetailData.length === 0) {
  //           this.virtualLoadingMemberDetailData = ["No records Found"];
  //           $("#displays").hide();
  //         } else {
  //           $("#displays").hide();
  //         }
  //       }, 10);

  //       // this.loadingDashboard = false;
  //     } else if (statusValue == statusFormats.noPahaf) {
  //       this.virtualLoadingMemberDetailData = this.copymemberDetailsData.filter(
  //         (x) => {
  //           return !x.status;
  //         }
  //       );
  //       this.virtualLoadingMemberDetailData = this.copymemberDetailsData.filter(
  //         (x) => {
  //           return !x.status;
  //         }
  //       );
  //       if (this.virtualLoadingMemberDetailData.length > 49) {
  //         $("#displays").show();
  //       } else if (this.virtualLoadingMemberDetailData.length === 0) {
  //         this.virtualLoadingMemberDetailData = ["No records Found"];
  //         $("#displays").hide();
  //       } else {
  //         $("#displays").hide();
  //       }
  //       // this.loadingDashboard = false;
  //     } else {
  //       this.allfilterFlag = true;
  //       this.completeFlag = false;
  //       this.incompleteFlag = false;

  //       this.copymemberDetailsData.map((data) => {
  //         if (temp && temp.length <= 49) {
  //           temp.push(data);
  //         }
  //       });
  //       setTimeout(() => {
  //         if (temp && temp.length) {
  //           if (this.searchInput) {
  //             this.completeFlag = false;
  //             this.incompleteFlag = false;
  //             this.virtualLoadingMemberDetailData = temp;
  //             this.filterMembers(
  //               this.searchInput,
  //               this.virtualLoadingMemberDetailData
  //             );
  //             this.loadingDashboard = false;
  //           } else {
  //             this.virtualLoadingMemberDetailData = temp;
  //             this.loadingDashboard = false;
  //           }
  //           //this.virtualLoadingMemberDetailData = this.copymemberDetailsData;
  //           //////console.log(
  //             "checking all the data",
  //             this.virtualLoadingMemberDetailData
  //           );
  //         }

  //         if (this.virtualLoadingMemberDetailData.length > 49) {
  //           $("#displays").show();
  //         } else if (this.virtualLoadingMemberDetailData.length === 0) {
  //           this.virtualLoadingMemberDetailData = ["No records Found"];
  //           $("#displays").hide();
  //         } else {
  //           $("#displays").hide();
  //         }
  //       }, 20);
  //       if (this.virtualLoadingMemberDetailData.length) {
  //         this.loadingDashboard = false;
  //       }
  //       // this.loadingDashboard = false;
  //     }
  //   } catch (err) {
  //     //////console.log("catch err", err);
  //     this.loadingDashboard = false;
  //   }
  // }

  closeGenerate() {
    this.selectedids = ' ';
    this.generateButtonFlag = true;
    this.disableDropdown = false;
  }

  public convertDateFormat(str) {
    try {
      if (str) {
        var month = str.slice(5, 7);
        var date = str.slice(8, 10);
        var year = str.slice(0, 4);
        var totalDate = month + '/' + date + '/' + year;
        return totalDate;
      } else {
        return '';
      }
    } catch (err) {
      throw err;
    }
  }

  priviewPdf() {
    // Populate modal render list only when opening the modal
    this.modalRenderList = [...this.checkedList];
    this.modalLoading = true;
    this.loadedFormsCount = 0;
    this.openModal('previewPDF');
  }

  onFormLoaded() {
    this.loadedFormsCount++;
    if (this.loadedFormsCount >= this.modalRenderList.length) {
      this.modalLoading = false;
    }
  }

  onFormError() {
    this.loadedFormsCount++;
    if (this.loadedFormsCount >= this.modalRenderList.length) {
      this.modalLoading = false;
    }
  }

  getChart() {
    this.openModal('previewChart');
  }

  closeChartModal() {
    this.isBulkDownloadModalOpen = false;
    window.document.getElementById('close_model_chart').click();
  }

  openBulkDownloadModal() {
    this.isBulkDownloadModalOpen = true;
  }
  /*
  printPdf(cb) {
    // var pdf = new jsPDF("p", "pt", "a4");
    var doc = new jsPDF('p', 'mm');
    const html2canvas: any = _html2canvas;
    this.PdfDataPresent = true;
    var eachPdf;
    ////////console.log('checkedList',this.checkedList);
    this.checkedList.forEach((tobeusedinfuture, pdfIndex) => {
      //if(pdfIndex > 0) pdf.addPage();
      html2canvas(document.getElementById("pahafPDF" + pdfIndex)).then((canvas) => {
        // var imgWidth = 210;
        // var pageHeight = 295;
        var imgWidth = doc.internal.pageSize.getWidth();
        var pageHeight = doc.internal.pageSize.getHeight();
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var position = 0;
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        var imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight+10);
        doc.setLineWidth(5);
        // doc.setDrawColor(255, 255, 255);
        // doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          doc.addPage();
          position = heightLeft - imgHeight;
          position +=15;
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight-10);
          doc.setLineWidth(5);
          // doc.setDrawColor(255, 255, 255);
          // doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        if (pdfIndex === this.checkedList.length - 1) {
          //////console.log('pdfIndex',pdfIndex,this.checkedList.length);
          cb(doc);
        } else {
          doc.addPage();
        }
      });


      // html2canvas(eachPdf).then((canvas) => {
      //   var imgData = canvas.toDataURL("image/png");
      //   var imgWidth = pdf.internal.pageSize.getWidth();
      //   var pageHeight = pdf.internal.pageSize.getHeight();
      //   var imgHeight = ((canvas.height * imgWidth) / canvas.width);
      //   var heightLeft = imgHeight;
      //   var position = 10;
      //   pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight, "", "FAST");
      //   heightLeft -= pageHeight;
      
      //   while (heightLeft >= 0 ) {
      //     position = ((heightLeft) - imgHeight);
      //     pdf.addPage();
      //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight, "", "FAST");
      //     heightLeft -= pageHeight;
      //   }
      //   if (pdfIndex === this.checkedList.length - 1) {
      //     cb(pdf);
      //   } else {
      //     pdf.addPage();
      //   }
      // })
      // ;
    });
  }

  generatePdf() {
    this.loadingDashboard = true;
    this.PdfDataPresent = true;
    // setTimeout(() => {
      this.printPdf((finalPDFTosave) => {
        if (finalPDFTosave) {
          setTimeout(() => {
          finalPDFTosave.save("pahafDocument.pdf");
   }, 150);
          this.loadingDashboard = false;
        }
      });
      
    // }, 200);
    
  }
  */
  addImage(url) {
    return new Promise((resolve) => {
      let img = new Image();
      img.onload = () => resolve(img);
      img.src = url;
    });
  }
  makeTemplate() {
    let path = '/providerportal/pahaf-form';
    this.router.navigateByUrl(path);
  }
  //change url
  async rowSelectionEpahaf(event: Event, memberDetails) {
    // let eachContentList = [];
    event.stopPropagation();
    event.preventDefault();

    if (!this.memberArrayList.includes(memberDetails.memberHmoID)) {
      this.memberArrayList.push(memberDetails.memberHmoID);
      // this.duplicates.push(memberDetails.memberHmoID);
      this.secureStorage.setSecureInfoInSessionlStorage(
        'arraylist',
        JSON.stringify(this.memberArrayList)
      );
    }
    if (memberDetails.status) {
      const userName = this.cupService.getUserNameFromJWT();
      let url = urls.getRedirectionURL;
      // url = url.replace('pID', memberDetails.memberHmoID);
      // url = url.replace('pCode', 'ProviderPortal');
      // url = url.replace('user_name', userName);

      const key = `hmodID=${memberDetails.memberHmoID}&appName=ProviderPortal&userName=${userName}`;
      const encryptedKey = this.util.aesencryptForStore(key);
      url = url.replace('encryptedKey', encryptedKey);
      
      // const decryptedId = this.encService.encrypt(memberDetails.memberHmoID);
      // const decryptedUserName = this.encService.encrypt(userName);
      //////console.log('url redirect :', url);
      window.open(url, '_blank');
    } else {
      this.openModal('noStatus');
    }
  }
  selectedMember(memberDetails, type, event?) {
    // Skip if select all is in progress
    if (this.isSelectAllInProgress) {
      return;
    }
    //this.medicationList = [];
    // $('.innerRows').hide();
    const displaysElement = document.getElementById('demo'+ this.indexOfClickedRow);
    if (displaysElement) {
      displaysElement.style.display = 'none';
    }
    if (type !== 'selectAll') {
      if (event.target.checked === true) {
        this.notChecked = false;
        if (this.counter < 15) {
          this.counter++;
        } else {
          event.target.checked = false;
          alert('Please select only 15 members.');
        }
      } else if (this.counter > 0) {
        this.counter--;
      }
    }
    if (event.target.checked) {
      // this.loadingDashboard = true;
      this.checkedList.push(memberDetails);
      ////console.log("chekedList", this.checkedList);
      this.notChecked = false;
    } else if (!event.target.checked) {
      ////console.log("not checked---")
      if (this.counter == 0) {
        this.notChecked = true;
      }
      this.checkedList = this.checkedList.filter(
        (x) => x.memberHmoID !== memberDetails.memberHmoID
      );
      this.selectedPdfObject = this.selectedPdfObject.filter(
        (item) => item.parentValue.memberHmoID !== memberDetails.memberHmoID
      );
    }
  }
  isChecked(id: number) {
    for (let index = 0; index < this.checkedList.length; index++) {
      if (id == this.checkedList[index].memberHmoID) {
        return true;
      }
    }
    return false;
  }
  //generate epahaf DOC
  generatEpahafDoc() {
    this.loadingDashboard = true;
    this.getLatest = [];
    this.getLatestforPahaf = [];
    this.getLatestforChart = [];
    let membersForepahafDocList = this.checkedList;
    membersForepahafDocList.forEach(async (memElement) => {
      let hmoId = memElement.memberHmoID;

      const kplv = [
        {
          value: hmoId,
          key: 'memberid',
        },
        {
          key: 'year',
          value: new Date().getFullYear(),
        },
      ];

      let docId, docCode, memberId, allDoc, createdDate, docType;
      let docContentList = [];
      let newDocContentList = [];
      let pahafDoclist = [];
      let pahafChartDoclist = [];

      //let  getLatest;

      this.epahafService.listofepahafDoc(kplv).subscribe(
        (epahafDocs: any) => {
          if (epahafDocs) {
            let docBody = epahafDocs;
            //////console.log("docBody", docBody);
            if (
              docBody.keyValuePairListWrapperlist &&
              docBody.keyValuePairListWrapperlist.length > 0
            ) {
              allDoc = this.generateList(docBody.keyValuePairListWrapperlist);
            }
          }

          //////console.log("allDoc", allDoc);
          allDoc.forEach((ele) => {
            if (ele.type) {
              docType = ele.type;
            }
            if (ele.Id) {
              docId = ele.Id;
            }
            if (ele.DocumentClass) {
              docCode = ele.DocumentClass;
            }
            if (ele.memberid) {
              memberId = ele.memberid;
            }
            if (ele.CreatedDate) {
              //let forDate = new Date(ele.CreatedDate)
              createdDate = ele.CreatedDate;
            }

            let docContent = {
              docId: docId,
              docCode: docCode,
              memberId: memberId,
              createdDate: createdDate,
              docType: docType,
            };
            if (docContent.docType === 'Chart') {
              docContentList.push(docContent);
              //////console.log("docContentList", docContentList);
            } else if (docContent.docType === 'PAHAF') {
              pahafDoclist.push(docContent);
              //////console.log("pahafDoc", pahafDoclist);
            } else if (docContent.docType === 'PAHAF/Chart') {
              pahafChartDoclist.push(docContent);
            }
          });
          this.getLatestforChart = docContentList;
          //////console.log("chart", this.getLatestforChart);
          this.getLatestforPahaf = pahafDoclist.sort(
            (a, b) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime()
          );

          docContentList.forEach((e) => {
            if (hmoId === e.memberId) {
              newDocContentList.push(e);
            }
          });
          this.getLatest = newDocContentList.sort(
            (a, b) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime()
          )[0];

          //////console.log(this.getLatest);
          this.epahafService
            .getDocument(this.getLatest.docId, this.getLatest.docCode, null)
            .subscribe((res) => {
              const responseData = res;
              if (responseData.docContent) {
                const linkSource =
                  'data:application/pdf;base64,' + responseData.docContent;
                const downloadLink = document.createElement('a');
                const fileName = responseData.filename;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                this.loadingDashboard = false;
              } else {
                this.loadingDashboard = false;
              }
            });
          this.getLatest = [];

          // }
        },
        () => {
          this.loadingDashboard = false;
        }
      );
      ///docContentList.forEach(element => {

      // },err =>{
      // //  this.loadingDashboard = false;
      // });
    });
  }
  checkTableRow(event) {
    // $(".showRows").css({ display: "none", background: "transparent" });
    // $(".accordion-toggle").css({ background: "transparent" });
    if (event.srcElement.nodeName == 'INPUT') {
      //event.srcElement.parentElement.parentNode.classList.add("arrowIcon");
      // event.srcElement.parentNode.parentElement.nextElementSibling["style"].display = 'none';
      //event.srcElement.parentNode.parentElement.nextElementSibling["style"].display
    }
    /*  if(event.srcElement.nodeName == 'INPUT' && event.srcElement.checked == 'true') {
        event.srcElement.parentNode.parentElement.nextElementSibling["style"].display = 'none';
      }*/
    if (
      event.srcElement.nodeName == 'TR' &&
      event.srcElement.nextElementSibling.attributes['id'].value ==
        event.srcElement.attributes['data-target'].value.slice(1)
    ) {
      //event.srcElement.parentElement.classList.add("arrowIconTR");
      event.srcElement.nextElementSibling['style'].display = 'table-row';
      event.srcElement.nextElementSibling['style'].background = '#cfe0ff';
      event.srcElement['style'].background = '#cfe0ff';
      // $("table.pagingTable tr, .previous, .next").hide();
      // $("#hdnActivePage").val(1);
    }
    if (
      event.srcElement.nodeName != 'TR' &&
      event.srcElement.parentNode.parentElement.nextElementSibling.attributes[
        'id'
      ].value ==
        event.srcElement.parentNode.parentElement.attributes[
          'data-target'
        ].value.slice(1)
    ) {
      // event.srcElement.parentNode.classList.add("arrowIconTR");
      event.srcElement.parentNode.parentElement.nextElementSibling[
        'style'
      ].display = 'table-row';
      event.srcElement.parentNode.parentElement.nextElementSibling[
        'style'
      ].background = '#cfe0ff';
      event.srcElement.parentNode.parentElement['style'].background = '#cfe0ff';
    }
  }

  showDoc(row, id) {
    // $('.accordian-body').on('show.bs.collapse', function () {
    //   $(this)
    //     .closest('table')
    //     .find('.collapse.in')
    //     .not(this)
    //     .collapse('toggle');
    // });
    this.indexOfClickedRow = row;
    this.golbalFileType = '';
    this.globalFiletypeforchart = '';
    this.openIndex = row; 
    this.cdr.detectChanges(); 
    const targetElement = document.getElementById('demo'+row);
    if (targetElement) {
        const collapseInstance = Collapse.getOrCreateInstance(targetElement);
        collapseInstance.toggle();
    }
    document.querySelectorAll('.accordian-body').forEach((element) => {
      element.addEventListener('show.bs.collapse', function () {
        const table = this.closest('table');
        if (table) {
          const openCollapses = table.querySelectorAll('.collapse.show');
          openCollapses.forEach((collapse) => {
            if (collapse !== this) {
              const collapseInstance = Collapse.getInstance(collapse);
              if (collapseInstance) {
                collapseInstance.hide();
              }
            }
          });
        }
      });
    });


    //////console.log(id);
    var patt1 = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    //this.loadingDashboard = true;
    this.getLatestforPahaf = [];
    this.getLatestforChart = [];
    this.getLatestforPahafChart = [];
    this.AllDocuments = [];
    let pahafYear = '';
    let allCardData = this.alertService.allCardData;
    let resultList = [];
    if (this.alertService.allCardData) {
      (<any[]>allCardData).forEach((element) => {
        let obj = {
          year: element.AlertName ? element.AlertName.split(':')[2] : '',
          memberId: element.AlertDetails
            ? element.AlertDetails.split('_')[0]
            : '',
        };
        resultList.push(obj);
      });
      this.cardDataWithMemberIdList = resultList;
    }
    let pahafAlert = this.cardDataWithMemberIdList.filter(
      (x) => x.memberId === id
    )[0];
    if (pahafAlert && pahafAlert.year !== '') {
      pahafYear = pahafAlert.year;
    } else {
      pahafYear = new Date().getFullYear().toString();
    }
    const kplv = [
      {
        value: id,
        key: 'memberid',
      },
      {
        key: 'year',
        value: new Date().getFullYear().toString(),
      },
    ];

    let docId,
      docCode,
      memberId,
      allDoc,
      createdDate,
      docTitle,
      docType,
      docExtension;
    let docContentList = [];
    let pahafDoclist = [];
    let pahafChartDoclist = [];
    //let  getLatest;
    this.documentLoading = true;
    this.epahafService.listofepahafDoc(kplv).subscribe(
      (epahafDocs: any) => {
        if (epahafDocs) {
          let docBody = epahafDocs;
          ////console.log("docBody", docBody);
          if (
            docBody.keyValuePairListWrapperlist &&
            docBody.keyValuePairListWrapperlist.length > 0
          ) {
            allDoc = this.generateList(docBody.keyValuePairListWrapperlist);
          }
        }
        if (allDoc) {
          allDoc.forEach((ele) => {
            if (ele.type) {
              docType = ele.type;
            }
            if (ele.Id) {
              docId = ele.Id;
            }
            if (ele.DocumentClass) {
              docCode = ele.DocumentClass;
            }
            if (ele.memberid) {
              memberId = ele.memberid;
            }
            if (ele.CreatedDate) {
              //let forDate = new Date(ele.CreatedDate)
              createdDate = ele.CreatedDate;
            }
            if (ele.DocumentTitle) {
              docTitle = ele.DocumentTitle;
            }
            if (ele.DocumentTitle) {
              docExtension = ele.DocumentTitle.match(patt1)[1];
            }
            let docContent = {
              docId: docId,
              docCode: docCode,
              memberId: memberId,
              createdDate: createdDate,
              docTitle: docTitle,
              docType: docType,
              docExtension: docExtension,
            };

            ////console.log("docContent -:",docContent)
            if (docContent.docType === 'Chart') {
              docContentList.push(docContent);
              ////console.log("docContentList--in chart", docContentList);
            } else if (docContent.docType === 'PAHAF') {
              pahafDoclist.push(docContent);
            } else if (docContent.docType === 'PAHAF/Chart') {
              pahafChartDoclist.push(docContent);
            }
          });
          this.getLatestforChart = docContentList;
          // this.getLatestforPahaf = pahafDoclist.sort(
          //   (a, b) =>
          //     new Date(b.createdDate).getTime() -
          //     new Date(a.createdDate).getTime()
          // )[0];

          //////console.log("pahafDoc", this.getLatestforPahaf);
          if (pahafDoclist.length > 0) {
            this.getLatestforPahaf = pahafDoclist;
          }

          if (pahafChartDoclist.length > 0) {
            this.getLatestforPahafChart = pahafChartDoclist;
          }

          if (this.getLatestforPahaf.length > 0) {
            ////console.log("this.getLatestforPahaf")
            for (var i = 0; i < this.getLatestforPahaf.length; i++) {
              docContentList.push(this.getLatestforPahaf[i]);
            }
          }

          if (this.getLatestforPahafChart.length > 0) {
            docContentList.push(this.getLatestforPahafChart[0]);
          }
          // setTimeout(() => {
          this.AllDocuments = docContentList;
          this.documentLoading = false;
          this.cdr.detectChanges();
        } else {
          this.noDocs = ['No Document found for this criteria'];
          //////console.log(this.noDocs);
          this.documentLoading = false;
          this.cdr.detectChanges();
        }
        //}, 10);
        ////console.log("allDocsss", this.AllDocuments);
      },
      () => {
        this.loadingDashboard = false;
        this.documentLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  generateList(list) {
    let array = [];
    list.map((row) => {
      let obj = {};
      row.keyvaluePairWr.map((item) => {
        obj[item.key] = item.value;
      });
      array.push(obj);
    });
    return array;
  }
  todaydateWithoutSymbols() {
    let current_datetime = new Date();
    let formatted_date =
      this.getFullMonth() +
      '' +
      current_datetime.getDate() +
      '' +
      current_datetime.getFullYear();
    let formatted_date_withoutSpace = formatted_date.trim();
    return formatted_date_withoutSpace;
  }
  getFullMonth() {
    let date = new Date();
    let month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month;
  }
  todaydate() {
    let current_datetime = new Date();
    let formatted_date =
      current_datetime.getMonth() +
      1 +
      '/' +
      current_datetime.getDate() +
      '/' +
      current_datetime.getFullYear();
    return formatted_date;
  }
  getDocument(docContent) {
    this.loadingDashboard = true;
    this.epahafService
      .getDocument(docContent.docId, docContent.docCode, null)
      .subscribe((res) => {
        const responseData = res;
        // if (state && (state.value === this.userState || this.clientAccessStates.includes(state.value)) || this.documentCode === 'GEN_REF_DOC') {

        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          const blob = this.binary64ToBlob(
            responseData.docContent,
            responseData.fileType,
            512
          );
          saveAs(blob, responseData.filename);
          this.loadingDashboard = false;
        } else {
          const blob = this.b64toBlob(
            responseData.docContent,
            responseData.fileType,
            512
          );
          //const urlBlob = URL.createObjectURL(blob);
          saveAs(blob, responseData.filename);
          // window.open(urlBlob, "_blank", "location=yes,height=570,width=520");
          this.loadingDashboard = false;
        }
      });
  }
  // closeExpandedRow() {
  //  this.openIndex = '';
  // }

  showPdfDocument(docContent) {
    this.loadingDashboard = true;
    this.epahafService
      .getDocument(docContent.docId, docContent.docCode, null)
      .subscribe((res) => {
        const responseData = res;
        // if (state && (state.value === this.userState || this.clientAccessStates.includes(state.value)) || this.documentCode === 'GEN_REF_DOC') {

        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          const blob = this.binary64ToBlob(
            responseData.docContent,
            responseData.fileType,
            512
          );
          saveAs(blob, responseData.filename);
          this.loadingDashboard = false;
        } else {
          const blob = this.b64toBlob(
            responseData.docContent,
            responseData.fileType,
            512
          );
          const urlBlob = URL.createObjectURL(blob);
          //saveAs(blob, responseData.filename);
          //window.open(urlBlob, "_blank", "location=yes,height=570,width=520");
          window.open(urlBlob, '_blank');
          this.loadingDashboard = false;
        }
      });
  }

  closeExpandedRow() {
    setTimeout(() => {
      this.indexOfClickedRow = undefined;
    }, 500);

    // $(".collapse").css("display", "none");
    // $(".accordion-toggle").css("background", "transparent");
  }

  uploadDocuments(row, id) {
    this.uploadmemid = '';
    this.uploadmemid = id;

    this.radioBtn = '';
    this.selectedFiles = [];
    this.selectedFilesSingle = [];
    this.selectedFilesBoth = [];
    this.Pahaffile = '';
    this.Chartfile = '';
    this.PahafChartfile = '';
    this.openModal('uploadFilledDocuments');
  }

  onFilechange1(event) {
    this.uploadFlag = true;
    this.uploadFlag1 = true;
    this.PahafChartfile = '';
  }

  onFilechange2(event) {
    this.uploadFlag = true;
    this.uploadFlag1 = true;
    this.Pahaffile = '';
    this.Chartfile = '';
  }

  private showPopuup(message: string) {
    this.message = message;
    this.openModal('alertModal');
    return;
  }

  private isSupportedFileType(fileType): boolean {
    // if(!event.target.files[0].type.match('.pdf') && !event.target.files[0].type.match('.docx')) {      
    if(fileType === 'application/pdf' || fileType === 'application/msword' ||
          fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {      
      return true;
    }

    return false;
  }

  onFilechange(event: any,type) { 
    this.uploadFlag = true;
    this.uploadFlag1 = true;
    this.selectedFiles = [];

    if(!this.isSupportedFileType(event.target.files[0].type)) {      
      this.showPopuup("The file type is not valid. Permitted document types are Word (.doc, .docx) and .PDF files")
      event.target.value = '';      
      return;
    }

    if (type == 'PAHAF' || 'Chart') {
      this.selectedFilesBoth = [];
      if (type == 'PAHAF') {
        this.Pahaffile = event.target.files[0].name;
      }
      if (type == 'Chart') {
        this.Chartfile = event.target.files[0].name;
      }
      this.file = event.target.files[0];
      if (this.file) {
        this.selectedFilesSingle.push({
          file: this.file,
          type: type,
        });
      }

      if (this.selectedFilesSingle.length >= 2) this.uploadFlag = false;
      else this.uploadFlag = true;
    }

    if (type == 'PAHAF/Chart') {
      this.selectedFilesSingle = [];
      if (type == 'PAHAF/Chart') {
        this.PahafChartfile = event.target.files[0].name;
      }
      this.file = event.target.files[0];
      if (this.file) {
        this.selectedFilesBoth.push({
          file: this.file,
          type: 'PAHAF',
        });
      }

      if (this.selectedFilesBoth.length >= 1) this.uploadFlag1 = false;
      else this.uploadFlag1 = true;
    }

    if (this.selectedFilesSingle.length > 0) {
      this.selectedFiles = this.selectedFilesSingle;
    }

    if (this.selectedFilesBoth.length > 0) {
      this.selectedFiles = this.selectedFilesBoth;
    }
  }

 uploadFiles(id) {
    const filesToUpload = [...this.selectedFiles];
    this.selectedFiles = [];
    this.selectedFilesSingle = [];
    this.selectedFilesBoth = [];

    if (filesToUpload.length === 0) return;

    this.isUploadLoading = true;
    let pending = filesToUpload.length;

    const onDone = async () => {
      pending--;
      if (pending === 0) {
        await this.getUploadStatus();
        this.isUploadLoading = false;

        this.closeModal('uploadFilledDocuments');
      }
    };

    for (const file of filesToUpload) {
      this.onUpload(file, id, onDone);
    }
  }

  onUpload(file1, id, onDone?: () => void) {
    let res = this.memberdetailsPdfData.filter(
      (item) => item.memberHmoID == id
    );
    this.epahafService
      .uploadFile(file1.file, [
        { key: 'DocumentTitle', value: file1.file.name },
        { key: 'memberid', value: res[0].memberHmoID },
        { key: 'type', value: file1.type },
        { key: 'Mode', value: 'Portal' },
        { key: 'pcpid', value: res[0].pcpId },
        { key: 'Year', value: new Date().getFullYear().toString() },
      ])
      .subscribe({
        next: (docResponse) => {
          const parseResp = JSON.parse(docResponse);
          if (parseResp && parseResp.errCode == null) {
            //check this error code condition
            let fileObj;
            fileObj = {
              actionType: 'A',
              createdDate: parseResp.createdDate,
              docGUID: parseResp.docGUID,
              docId: parseResp.docId,
              documentName: file1.file.name,
              documentType: file1.type,
              documentYear: new Date().getFullYear().toString(),
              errCode: parseResp.errCode,
              errMessage: parseResp.errMessage,
              fileSubmissionDate: '',
              memberId: res[0].memberHmoID,
              mode: 'Portal',
              pcpID: res[0].pcpId,
              versionSeriesID: parseResp.versionSeriesID,
            };
            this.epahafService.saveDocumentDetails(fileObj).subscribe({
              next: (resp) => {
                let response: any = resp;
                if (response.successFlag == true) {
                  //if(res[0].status == "Not Received" || res[0].status == "Provider feedback") {
                  if (res[0].status == 'Not Received') {
                    if (!this.memberArrayListUpload.includes(res[0].memberHmoID)) {
                      this.memberArrayListUpload.push(res[0].memberHmoID);
                      this.secureStorage.setSecureInfoInSessionlStorage(
                        'arraylistUpload',
                        JSON.stringify(this.memberArrayListUpload)
                      );
                    }
                  }
                } else {
                  //console.log("Error in uploading file response in DXGAPS--Pahaf:")
                }
                if (onDone) onDone();
              },
              error: () => {
                if (onDone) onDone();
              }
            });
          } else {
            ////console.log("Error in uploading file:")
            if (onDone) onDone();
            this.openModal('docErrorModal');
          }
        },
        error: () => {
          if (onDone) onDone();
        }
      });
  }

  showDeleteModal(itemId, prvname) {
    this.fileId = itemId;
    this.deleteprvname = prvname;
    this.openModal('deleteModal');
  }

  deleteDocument(item, prvName) {
    this.epahafService
      .deleteuploadedDoc(item, prvName)
      .subscribe((docResponse) => {
        let responseData: any = docResponse;
        this.AllDocuments = this.AllDocuments.filter(
          (file) => responseData.docID !== file.docId
        );
        if (responseData && responseData.errCode == null) {
          let fileObj;
          fileObj = {
            actionType: 'D',
            createdDate: '',
            docGUID: responseData.docGUID,
            docId: responseData.docId,
            documentName: '',
            documentType: '',
            documentYear: '',
            errCode: responseData.errCode,
            errMessage: responseData.errMessage,
            fileSubmissionDate: '',
            memberId: '',
            mode: '',
            pcpID: '',
            versionSeriesID: '',
          };
          // //console.log("delete obj :",fileObj)
          this.epahafService.saveDocumentDetails(fileObj).subscribe((resp) => {
            ////console.log("delete response from DxGaps:",response);
          });
        } else {
          //console.log("Error in uploading file:")  // check for error message.
        }
      });
  }

  calculateDiff(dateSent) {
    this.uploadDocumentFlag = false;
    if (dateSent != null) {
      let currentDate: any = new Date();
      dateSent = new Date(dateSent);
      const milliseconds = Math.abs(currentDate - dateSent);
      const hours = milliseconds / 36e5;

      ////console.log("difference hours --1 :",hours);
      if (hours > 24) {
        return 1;
      } else {
        this.uploadDocumentFlag = true;
        return 0;
      }
    }
  }

  showDocument() {
    //console.log("showDocument--")
  }

  hoveringMethod(row) {
    this.hovering = true;
    this.hoveringRow = row;
  }
  hoveringVal() {
    this.hovering = false;
  }
  binary64ToBlob(binary64String, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(binary64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  openFrame() {
    this.openFrameFlag = true;
    this.RosterForm = this.fb.group({
      rosterType: [],
    });
    this.errorForCriteria = false;
    this.disableDropdown = false;
    this.generateButtonFlag = true;
    this.openModal('PCPModal');
  }
  public AlertAction() {
    this.openModal('Alertdialogpahaf');
  }
  getAllAlerts() {
    try {
      this.isUnReadValue = false;
      this.noCardFoundforHigh = false;

      let unfilteredCardData = this.alertService.allCardData;
      this.cardData = unfilteredCardData.filter((x) => {
        if (x.APPLICATION_ID !== null) {
          return x.APPLICATION_ID.toLowerCase() === this.appValue;
        }
      });
      //////console.log("card", this.cardData);
      if (
        this.cardData &&
        Array.isArray(this.cardData) &&
        this.cardData.length >= 1
      ) {
        this.isUnReadValue = this.cardData.every((temp: any) => {
          return temp.IsUnRead === '0';
        });
        //////console.log(this.isUnReadValue);
        let filteredHighCardData = this.cardData.filter(
          (x: any) => x.Severity.toLowerCase() === 'high'
        );
        this.noCardFoundforHigh = filteredHighCardData.every((temp: any) => {
          return temp.IsUnRead === '0';
        });
        //////console.log("noCardFoundforHigh", this.noCardFoundforHigh);
      } else if (
        this.cardData &&
        Array.isArray(this.cardData) &&
        this.cardData.length === 0
      ) {
        this.isUnReadValue = true;
        this.noCardFoundforHigh = true;
      } else if (!this.cardData) {
        this.isUnReadValue = true;
        this.noCardFoundforHigh = true;
      } else {
        this.isUnReadValue = false;
        this.noCardFoundforHigh = false;
      }
    } catch (e) {
      //////console.log(e);
    }
  }
  getStatusAlert(alertMetaData) {
    this.epahafService
      .getReadStatus(alertMetaData.AlertId)
      .subscribe((response): any => {
        let indexToDel;
        if (response) {
          this.alertService.getAllCounts();
          let CloneOfMainCardArray = this.cardData;
          CloneOfMainCardArray.forEach((alert, index) => {
            if (alert.AlertId === alertMetaData.AlertId) {
              if (alert.open) {
                alert.open = false;
              } else {
                alert['open'] = true;
              }
              if (!alert.isCardOpened) {
                alert['isCardOpened'] = true;
              }

              indexToDel = index;
            }
          });
          //  setTimeout(() => {
          this.cardData = CloneOfMainCardArray;
          this.alertService.allCardData[indexToDel]['isCardOpened'] = true;
          //this.unReadAlertCounts();
          // For del of alert// this.cardData = CloneOfMainCardArray.splice(indexToDel, 1);
          // }, 10);
        }
      });
  }
  ngOnDestroy() {
    localStorage.removeItem('dataSaved');
    if (this.dataForInterval) {
      clearInterval(this.dataForInterval);
    }
    if (this.dataForUpload) {
      clearInterval(this.dataForUpload);
    }
    if (this.intervalForLoading) {
      clearInterval(this.intervalForLoading);
    }
    this.cardData = [];
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.countSubscription) {
      this.countSubscription.unsubscribe();
    }
    if (this.highCountSubscription) {
      this.highCountSubscription.unsubscribe();
    }
    if (this.medCountSubscription) {
      this.medCountSubscription.unsubscribe();
    }
    if (this.lowCountSubscription) {
      this.lowCountSubscription.unsubscribe();
    }
    if (this.allCountSubscription) {
      this.allCountSubscription.unsubscribe();
    }
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');

      img.onload = () => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };
      img.src = url;
    });
  }

  async downloadAsPDF() {
    this.loadingDashboard = true;
    //this.images.logo = await this.getBase64ImageFromURL("assets/images/logo_new1.png");CareMore.png
    this.images.logo = await this.getBase64ImageFromURL(
      'assets/images/logo.png'
    );
    this.images.systolic = await this.getBase64ImageFromURL(
      'assets/images/systolic.png'
    );
    this.images.cancerScreening = await this.getBase64ImageFromURL(
      'assets/images/cancerScreening.png'
    );
    this.images.signature = await this.getBase64ImageFromURL(
      'assets/images/signature.png'
    );
    this.images.alogo = await this.getBase64ImageFromURL('assets/images/A.PNG');
    this.images.dlogo = await this.getBase64ImageFromURL('assets/images/D.PNG');
    this.images.ulogo = await this.getBase64ImageFromURL('assets/images/U.PNG');
    this.images.adulogo = await this.getBase64ImageFromURL(
      'assets/images/ADU.PNG'
    );
    this.images.diabetes = await this.getBase64ImageFromURL(
      'assets/images/diabetes.png'
    );
    this.images.checkbox = await this.getBase64ImageFromURL(
      'assets/images/checkbox.svg'
    );
    this.images.rectBig = await this.getBase64ImageFromURL(
      'assets/images/rectBig.svg'
    );
    this.images.starMeasure = await this.getBase64ImageFromURL(
      'assets/images/starMeasure.png'
    );
    const newchecklist = [...this.checkedList];
    this.selectedPdfObject.forEach((pdf, pdfIndex) => {
      this.PdfService.generate(
        pdf,
        this.images,
        pdfIndex,
        newchecklist,
        this.pahafYear
      );
    });
    this.loadingDashboard = false;
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  async chunkDownload(){
    this.loadingDashboard = true;
 
   let memberPahafData = await this.pahafService.getbulkPaHafData("",this.username).toPromise();
   //console.log("memberPahafData -----:",memberPahafData)
    let respDataPahaf: any = []
   
   memberPahafData.responseDatasArray.forEach((element) => {
      respDataPahaf.push(JSON.parse(element));
    });

    //console.log("respDataPahaf -----:",respDataPahaf)
    let memberID0 = this.selectedmemberdetailsPdfData.length >0 ?this.selectedmemberdetailsPdfData[0].memberHmoID :""
    const codingConstantresp: any = await this.pahafService
    .getMeasuresQualityCoding(memberID0)
    .toPromise();
    let codingConstant = [];
    codingConstantresp.responseDatasArray.forEach((element) => {
      codingConstant = element.qualityCodingList;
    });

    //console.log("this.selectedmemberdetailsPdfData----- :",this.selectedmemberdetailsPdfData)
   
// this.checkedList = singleChunk;
      for (const singleMember  of this.selectedmemberdetailsPdfData){
 
        this.qualityCodingList = []
        this.qualityHeaderList = []
        this.resultHcc = [];
        this.resultDx = [];
        this.refreshDateN = [];
        this.uniquePrevCondition = [];
        this.memberMeasureDatas = [];
        this.measuresListDataArray = [];
 
        let memberPahafData:any = respDataPahaf.find(item => item[singleMember.memberHmoID]);
        memberPahafData = memberPahafData ? memberPahafData[singleMember.memberHmoID] : {};
       
 
    //     const resp: any = await this.pahafService
    // .getMeasuresQualityCoding(singleMember.memberHmoID)
    // .toPromise();
    // let responseMeasureData: any;
    // responseMeasureData = resp.responseDatasArray;
 
    this.measuresListData = memberPahafData.openQualityMeasure;//responseMeasureData[0].measuresList;
    if (this.measuresListData) {
      this.measuresListData.forEach((rec) => {
        this.refreshDate = this.pipe.transform(rec.refreshDate, 'MM-dd-yyyy');
        this.measuresListDataArray.push(rec);
      });
      if (this.refreshDate) {
        this.refreshDateN.push(this.refreshDate);
      }
    }
 
    this.qualityCodingListData = codingConstant;//responseMeasureData[0].qualityCodingList;
    this.qualityCodingListData.forEach((item, index) => {
      let quality = {} as QualityCodingGuide;
      quality.LOOKUP_ID = item.qualityID;
      quality.LOOKUP_TYPE = item.qualityType;
      quality.LOOKUP_CODE = item.qualityCode;
      quality.LOOKUP_DESCRIPTION = item.qualityDescription;
      quality.LOOKUP_PARENT_ID = item.qualityParentID;
 
      if (item.qualityType == "Quality_Header") {
        this.qualityHeaderList.push(quality);
      }
      if (item.qualityType == "Quality_Coding") {
        this.qualityCodingList.push(quality);
      }
    });
 
   
    let duplicates = [];
 
        // const combinedREsponses = await
        //   this.pahafService.getPahafDetailsforEachMembers(singleMember?.memberHmoID).toPromise();
           //console.log("combinedREsponses", combinedREsponses);
      // Populate formDataArray by combining previous and potential data
      this.formDataArray =[
        {
          lastName: memberPahafData?.lastname,
          firstName : memberPahafData?.firstname,
          providerName : memberPahafData?.providerName,
          memberGender  : memberPahafData?.gender,
          memberType  : memberPahafData?.memberType,
          providerNetwork  : memberPahafData?.pcpNetwork,
          pCPNeighborhood  : memberPahafData?.pcpNeighborhood,
          memberId:singleMember.memberHmoID
 
        }
      ]
      memberPahafData.previous.map(item => {
        item.dXCode = item.dxCode || null;
        item.hccId = item.hccID || null;
        item.suspectcondition = item.suspectCondition || null;
        item.moddcohort = item.moddCohort || null;
        item.pcpreportedDate = item.pcpReportedDate || null;
        item.dXDescription = item.dxDescription || null;
        item.instruction = item.instruction || null;
      });
      memberPahafData.potential.map(item => {
        item.dXCode = item.dxCode || null;
        item.hccId = item.hccID || null;
        item.suspectcondition = item.suspectCondition || null;
        item.moddcohort = item.moddCohort || null;
        item.pcpreportedDate = item.pcpReportedDate || null;
        item.dXDescription = item.dxDescription || null;
        item.instruction = item.instruction || null;
      });
      //  [...(memberPahafData.previous || []), ...(memberPahafData.potential || [])];
      this.singleMemberdetails = this.formDataArray[0];
      //console.log('formDataArray',this.formDataArray)
      let filterdPrevCondition = memberPahafData.previous;
      this.prevCondition = filterdPrevCondition
        .map(function (item) {
          if (item.hccId === '108') {
            item.hccId = '18';
          }
 
          return item;
        })
        .sort(
          (a, b) =>
            a.memberId - b.memberId ||
            a.hccId - b.hccId ||
            a.dXCode - b.dXCode
        );
      this.prevCondition.map((e) => {
        if (!duplicates.includes(e.dXCode)) {
          this.uniquePrevCondition.push(e);
 
          duplicates.push(e.dXCode);
        }
      });
      //console.log("this.prevCondition ---:",this.prevCondition);
 
      const NewPRflag = this.prevCondition.filter(data => data.dXCode == null );
      //console.log("NewPRflag ---:",NewPRflag);
 
      this.memberMeasureDatas = memberPahafData.memberMeasures || [];//combinedREsponses[1].responseDatasArray;
      //console.log("uniquePrevCondition----:",this.uniquePrevCondition)
 
       if (NewPRflag.length > 0) {
          this.prevFlag = false;
        } else {
          this.prevFlag = true;
        }
 
      //console.log("this.prevFlag----:",this.prevFlag);
 
          this.poteintialCondition = memberPahafData.potential
      // this.poteintialCondition = memberPahafData.potential
      //   .sort(
      //     (a, b) =>
      //       (b.moddcohort &&
      //         a.moddcohort &&
      //         b.moddcohort
      //           .toUpperCase()
      //           .localeCompare(a.moddcohort.toUpperCase())) ||
      //       (a.suspectcondition &&
      //         b.suspectcondition &&
      //         a.suspectcondition.localeCompare(b.suspectcondition)) ||
      //       (a.indicatorDescription &&
      //         b.indicatorDescription &&
      //         a.indicatorDescription.localeCompare(b.indicatorDescription)) ||
      //       (a.indicatorDOS &&
      //         b.indicatorDOS &&
      //         a.indicatorDOS
      //           .split('-')
      //           .reverse()
      //           .join('')
      //           .localeCompare(b.indicatorDOS.split('-').reverse().join('')))
      //   );
 
        //console.log("this.poteintialCondition before----:",this.poteintialCondition)
        this.dxDt = this.poteintialCondition.filter(dxData => dxData.healthplan === 'Navina');
        //console.log("dxDt ----:",this.dxDt);
        this.hccDt = this.poteintialCondition.filter(dxData => dxData.healthplan !== 'Navina');
        //console.log("hccDt-----:",this.hccDt);
 
        const NewPTflag = this.poteintialCondition.filter(data => data.dXCode == null && data.hccId == null);
      //console.log("NewPTflag ---:",NewPTflag);
 
 
                 
 
      // let grouped = _.groupBy(this.poteintialCondition, "suspectCondition");
     
      // let grouped = _.groupBy(this.poteintialCondition, 'hccDescription');
      // this.result = Object.keys(grouped).map((key) => [
      //   key,
      //   _.uniqBy(grouped[key], 'dXCode'),
      // ]);
 
      if(this.dxDt.length) {
 
      let grouped = _.groupBy(this.dxDt, 'dXCode');
      this.resultDx = Object.keys(grouped).map((key) => [
        key,
        _.uniqBy(grouped[key], 'dXCode'),
      ]);
 
      }
      if(this.hccDt.length) {
 
      let grouped = _.groupBy(this.hccDt, 'hccDescription');
      this.resultHcc = Object.keys(grouped).map((key) => [
        key,
        _.uniqBy(grouped[key], 'dXCode'),
      ]);
 
      }
 
      // console.log("resultDx---:",this.resultDx);
      // console.log("resultHcc--:",this.resultHcc)
 
 
      if (NewPTflag.length > 0) {
          this.ptnFlag = false;
        } else {
          this.ptnFlag = true;
        }
 
      //console.log("this.ptnFlag----:",this.ptnFlag);
 
      // this.formDataArray.map((eachResponse) => {
        // this.memberId = eachResponse.memberId;
        if (memberPahafData.gender === 'F') {
          this.gender = 'Female';
        } else {
          this.gender = 'Male';
        }
        if (memberPahafData.dob) {
          this.date = memberPahafData.memberDateOfBirth;
        }
        this.date_gender = this.date + ',' + this.gender;
      // });
      //console.log("this.result measuresListDataArray----:",this.refreshDateN);
      let Obj: any = {
        formDataArray: this.formDataArray,
        parentValue: singleMember,
        previousCondition: this.uniquePrevCondition,
        poteintialConditionDataDx: this.resultDx,
        poteintialConditionDataHcc: this.resultHcc,
        memberMeasureDatas: this.memberMeasureDatas,
        qualityHeaderList: this.qualityHeaderList,
        qualityCodingList: this.qualityCodingList,
        measuresListData: this.measuresListDataArray,
        refreshDate : this.refreshDateN,
        prevFlag : this.prevFlag,
        ptnFlag : this.ptnFlag,
 
      };
      this.pahafService.setEpahafpdData(Obj);
 //console.log("this.formDataArray---- :",this.formDataArray)
      }
     
    // Wait for all subscriptions to complete before downloading PDF
    this.loadingDashboard = false;
    this.downloadAsPDF();
    
  }

  sleep = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));

// Computed property that slices your master dataset dynamically for the table template
get paginatedData(): any[] {
  if (!this.virtualLoadingMemberDetailData) return [];
  const startIndex = (this.currentPage - 1) * this.pageSize1;
  return this.virtualLoadingMemberDetailData.slice(startIndex, startIndex + this.pageSize1);
}

// Computes the maximum page index threshold
get totalPages(): number {
  if (!this.virtualLoadingMemberDetailData || this.virtualLoadingMemberDetailData.length === 0) {
    return 1;
  }
  return Math.ceil(this.virtualLoadingMemberDetailData.length / this.pageSize1);
}

// Action method called by the pagination controls UI
changePage(newPage: number): void {
  if (newPage >= 1 && newPage <= this.totalPages) {
    this.currentPage = newPage;
    this.indexOfClickedRow = -1; // Reset clicked highlights on page shift
  }
}

// Important fix: If filtering or sorting changes the master list, reset to page 1
onSortClick1(event: any, field: string) {
  this.currentPage = 1; 
  // ... keep your existing sorting handler execution logic here ...
}

}



export interface IMemberIdYearMapping {
  year: string;
  memberId: string;
}
